import { createContext, useContext, useEffect, useState } from "react";
import { js_utils } from "../utils/frfr-js-utils";
import { _zzsurvey_ajax, _zzsurvey_authUtils, _zzsurvey_urlLib } from "../utils/zz/zz-zzsurvey-ajax-adapter";
import { _zzsurvey_utils_backendQuizBlueprint_to_quizBlueprint, _zzsurvey_utils_quizEditorState_to_quizBlueprint_preview } from "../utils/zz/zz-zzsurvey-quiz-utils";
import { _zzsurvey_formDefiinitionClient, _zzsurvey_formDefiinitionCustomer_v2, _zzsurvey_formDefiinitionInstance, _zzsurvey_formDefiinitionLogin, _zzsurvey_formDefiinitionRegisterSuperadmin, _zzsurvey_formDefiinitionRegisterSeller, _zzsurvey_utils_export_excel_table_v0_1, _zzsurvey_utils_make_date_now_plus_days, _zzsurvey_formDefinitionGoogleReviewsApi, _zzsurvey_formDefiinitionCdpCustomer, _zzsurvey_formDefiinitionSignConsent, _zzsurvey_formDefiinitionConsent } from "../utils/zz/zz-zzsurvey-utils";
import Btn from "./Btn";
import CardCollapsible from "./CardCollapsible";
import FormFieldGenerator from "./FormFieldGenerator";
import FormGenerator from "./FormGenerator";
import JSDisplayValue from "./JSDisplayValue";
import ModalBottomSheetKoglovoPresentational from "./ModalBottomSheetKoglovoPresentational";
import ModalPortableContainer from "./ModalPortableContainer";
import ViewGeneratorSimple from "./ViewGeneratorSimple";
import ZZTempSurveyQuizFill from "./ZZTempSurveyQuizFill";
import { ZZTempSurveyQuizEditorContainer } from "./ZZTempSurveyQuizEditor";
import SpinnerClassic from "./SpinnerClassic";
import { useModal } from "../hooks/useModal";
import { useDispatch } from "react-redux";
import { browser_utils } from "../utils/frfr-browser-utils";
import FrfrUtilsCbWhenMounted from "./FrfrUtilsCbWhenMounted";
import SidebarOption from "./SidebarOption";
import RenderIfTrue from "./RenderIfTrue";
import FormCsvEditorWidget from "./FormCsvEditorWidget";
import { useCsvEditorWidget } from "../hooks/useCsvEditorWidget";
import { app_build_version_id } from "..";
import ZZTempDialogUniversal from "./ZZTempDialogUniversal";
import ZZTempQRCodeForSignConsent from "./ZZTempQRCodeForSignConsent";
import ZZTempSignConsent from "./ZZTempSignConsent";
import { consent_1_text_20250506 } from "../utils/zz/zz-zzsurvey-dummy";
import FrfrUtilsCbUseEffect from "./FrfrUtilsCbUseEffect";
import ZZTempDialogSignConsent from "./ZZTempDialogSignConsent";


/*
TODO
create customer umesto customer_id arrray customer_ids
forma za schedule survey da bude funkcija koja se razlikuje kada je u pitanju mod za jednog customera ili multiple 
*/



// ZZSURVEY
const app_build_version_id_zzsurveyapp = 'frontend-build2025-05-13r2'; // UNIQUE ID FOR LAST CHANGES TO THIS 
// const app_build_version_id_zzsurveyapp = app_build_version_id; // UNIQUE ID FOR LAST CHANGES TO THIS 

export const ZZTempSurveyContext = createContext(null);

const global_data_ref = {};

export const config_TOKEN_LOCAL_KEY = 'ratemyservice_token';


//
const ZZTempSurveyAdminPanel = (props) => {
  return (
    <>
    </>
  );
};


//
const SellerCardPage = (props) => {
  const {
    disabled,
    pageRouteActive,
  } = props;
  if (disabled === true || pageRouteActive === false) {
    return (<></>);
  }
  if (pageRouteActive === true) {
    return (
      <div>
        {
          props.disableHeader !== true && (props.jsxHeader)
        }
        {props.children}
      </div>
    );
  }
  // else
  return (
    <CardCollapsible extraClass={props.extraClass} small={props.small} jsxHeader={props.jsxHeader}>{props.children}</CardCollapsible>
  );
};

//
const ZZTempSurveyPublicPageLanding = (props) => {
  const { detected_env } = props;
  return (
    <div className="zzsurvey__layout-page-wrapper zzsurvey__layout-page-wrapper--public">
      {
        detected_env === 'DEV' && (
          <div className="zzsurvey-app__env">DEV ENVIRONMENT</div>
        )
      }
      {
        detected_env === 'STG' && (
          <div className="zzsurvey-app__env">STG ENVIRONMENT FOR TESTING</div>
        )
      }
      <div className="flex-1"></div>
      <div className="zzsurvey__landing-content">
        <h1>ratemyservice.rs portal</h1>
        <p>Check your email for survey link :)</p>
      </div>
      <div className="flex-2"></div>
    </div>
  );
};


//
const ZZTempSurveyPublicPageFillSurvey = (props) => {
  const { dispatchShowToast } = useModal();
  const {
    // appState,
    quiz_key,
    detected_env,
  } = props;
  // console.log('appState.url_path', appState.url_path);
  // console.log('appState.quiz_key', appState.quiz_key);
  // const quiz_key = appState.quiz_key;
  console.log('quiz_key', quiz_key);

  const [state, setState] = useState({
    // quiz_key: null, // for example 1efa872f-f420-11ef-aa41-408d5c741508	
    fetching: true,
    fetchingSubmit: true,
    error: null,
    thank_you: false,
    is_review: false,
    review_text: null,
    review_link: null,
    backendQuizBlueprint: null,
  });

  const error_msg_handle = (err) => {
    let error_msg = 'Error!';
    if (typeof err?.response?.data?.message === 'string') {
      error_msg = err.response.data.message;
    }
    /*
    if (err?.response?.data?.error === "jwt expired") {
      error_msg = 'You must login again!';
    } else {
      console.log(err?.response?.data?.error);
      console.log(err?.response?.data?.error?.type);
      if (err?.response?.data?.error?.type === "field") {
        error_msg = err.response.data.error.msg;
      } else {
        if (typeof err?.response?.data?.message === 'string') {
          error_msg = err.response.data.message;
        } else {
          if (err?.response?.status === 404) {
            error_msg = '404 API route not found';
          }
        }
      }
    }
    */
    dispatchShowToast(error_msg, 'RED');
  };

  const fetchQuizBlueprint = (quiz_key) => {
    setState({
      ...state,
      fetching: true,
    });
    // _zzsurvey_ajax.getSurveyTemplate(quiz_key)
    _zzsurvey_ajax.getSurveyInstance(quiz_key)
      // _zzsurvey_ajax._get_test(state.quiz_key)
      .then((response) => {
        console.log(response);
        if (Array.isArray(response?.data?.survey?.questions)) { // validate quick
          // SUCCESS
          /*
          {
              "message": "Survey responses retrieved successfully.",
              "survey": {
                  "survey_instance_id": "a06642d4-f516-11ef-9b41-96000417eff7",
                  "date_filled": "2025-02-27T17:35:04.000Z",
                  "status": "filled",
                  "is_first_email_sent": false,
                  "is_second_email_sent": false,
                  "date_to_send_first_email": "2025-03-26T23:00:00.000Z",
                  "date_to_send_second_email": "2025-04-26T22:00:00.000Z",
                  "customer_id": 1,
                  "survey_template_id": 2,
                  "title": "ANKETA",
                  "text": "Anasdalkdsalksdj",
                  "img_url": null,
                  "date_created": "2025-02-27T14:22:45.000Z",
                  "date_due": "2030-12-30T23:00:00.000Z",
                  service_type //
                  "client": {
                      "client_id": 1,
                      "name": "AKKOMPRESOR",
                      "email": "ak@gmail.com",
                      "phone": "+381648102360",
                      "logo": null,
                      "is_active": true
                  },
                  "questions": [
                      {
                          "question_id": 1,
                          "question_type": "text",
                          "title": "PITANJE 1",
                          "a": null,
                          "b": null,
                          "c": null,
                          "d": null,
                          "e": null,
                          "f": null,
                          "g": null,
                          "h": null,
                          "i": null,
                          "j": null,
                          "opt_scale100": null,
                          "opt_scale75": null,
                          "opt_scale50": null,
                          "opt_scale25": null,
                          "opt_scale0": null,
                          "checklist": null,
                          "extra_answer_enabled": false,
                          "extra_answer_required": null,
                          "extra_question_title": null,
                          "extra_answer_condition": null,
                          "answer_id": 1,
                          "answer": "odgovor....",
                          "extra_answer": null
                      }
                  ]
              }
          }
          */
          // "pending" "filled" "expired"
          console.log('response.data.survey.status', response.data.survey.status);
          if (response.data.survey.status === "filled") { // ALREADY FILLED
            setState({
              ...state,
              fetching: false,
              backendQuizBlueprint: null,
              error: 'You have already answered this survey.',
            });
          } else if (response.data.survey.status === "expired") { // EXPIRED
            setState({
              ...state,
              fetching: false,
              backendQuizBlueprint: null,
              error: 'We are sorry but your survey has expired :(',
            });
          } else { // GOOD TO GO
            setState({
              ...state,
              fetching: false,
              backendQuizBlueprint: response.data.survey,
              error: null,
            });
          }
        } else {
          setState({
            ...state,
            fetching: false,
            backendQuizBlueprint: null,
            error: 'ERROR in quiz blueprint'
          });
        }
      })
      .catch(err => {
        console.log('CATCH error getSurveyInstance', err);
        let error = 'ERROR on server.';
        console.log(err?.response?.data?.error);
        if (err?.response?.data?.error?.type === "field" && err?.response?.data?.error?.location === "params") {
          error = 'ERROR There is no survey with that key! Check URL.';
        } else {
          error_msg_handle(err);
        }
        setState({
          ...state,
          fetching: false,
          backendQuizBlueprint: null,
          error: error,
        });
      })
  };

  const fetchSubmitFillSurvey = (id, entbox) => {
    console.log('fetchSubmitFillSurvey ... (id, entbox)', id);
    _zzsurvey_ajax.fillSurvey(id, entbox)
      .then((response) => {
        console.log('submit response', response);
        // SUCCESS
        let is_review = false;
        if (state.backendQuizBlueprint?.is_review === true) {
          is_review = true;
        }
        setState({
          ...state,
          fetchingSubmit: false,
          error: null,
          thank_you: true,
          is_review,
          review_text: state.backendQuizBlueprint?.review_text,
          review_link: state.backendQuizBlueprint?.review_link,
        });
      })
      .catch(err => {
        console.log('CATCH error fillSurvey quiz answers', err);
        error_msg_handle(err);
        setState({
          ...state,
          fetchingSubmit: false,
          error: 'ERROR on server while submiting your answers.',
          thank_you: false,
        });
      })
  };

  /*
  useEffect(() => {
    const url_path = appState.url_path;// /survey/abcdef
    console.log('useEffect appState.url_path');
    if (typeof url_path === 'string' && url_path.indexOf('/survey/') === 0) {
      console.log('route contain /survey/');
      const quiz_key = url_path.split('/')[2]; // ['', 'survey', 'abcdef']
      console.log('detected quiz_key', quiz_key);
      setState({
        ...state,
        quiz_key: quiz_key,
      });
    } else {
      console.log('ERROR IN URL PATH');
      setState({
        ...state,
        // quiz_key: null,
        error: 'ERROR There is no survey with that key! Check URL.'
      });
    }
  }, [appState.url_path]);
  */
  useEffect(() => {
    console.log('useEffect quiz_key');
    browser_utils.browser_title_set('RateMyService portal - We want to hear from you');
    if (quiz_key) {
      fetchQuizBlueprint(quiz_key);
    } else {
      console.log('ERROR IN URL PATH');
      setState({
        ...state,
        // quiz_key: null,
        fetching: false,
        error: 'ERROR There is no survey with that key! Check URL.'
      });
    }
  }, [quiz_key]);


  let jsxSpinner = null;
  if (state.fetching === true) {
    jsxSpinner = (
      <div className="zzsurvey__bar-vector-with-spinner"><SpinnerClassic inlineSmall /> <b>Please wait...</b> <span>(fetching quiz: {quiz_key})</span></div>
    );
  }

  if (state.thank_you === true) {
    // <h1>Thank you for your feedback! :)</h1>
    // <h1>Hvala Vam na povratnim informacijama! :)</h1>
    return (
      <div className="zzsurvey__layout-page-wrapper zzsurvey__layout-page-wrapper--public">
        {
          detected_env === 'DEV' && (
            <div className="zzsurvey-app__env">DEV ENVIRONMENT</div>
          )
        }
        {
          detected_env === 'STG' && (
            <div className="zzsurvey-app__env">STG ENVIRONMENT FOR TESTING</div>
          )
        }
        <div className="flex-1"></div>
        <div className="zzsurvey__landing-content">
          <div className="zzsurvey__pad-16px">
            <h1>Hvala Vam na povratnim informacijama! :)</h1>
            {
              state.is_review === true && (
                <div className="zzsurvey__review">
                  <p className="zzsurvey__review__text">{state.review_text}</p>
                  <a className="zzsurvey__review__link" target="_blank" rel="noopener noreferrer" href={state.review_link}>{state.review_link}</a>
                </div>
              )
            }
          </div>
        </div>
        <div className="flex-2"></div>
      </div>
    );
  }

  let jsxTestFakeQuiz = null;
  /*
  jsxTestFakeQuiz = (
    <ZZTempSurveyQuizFill
      mode={'LIVE_PREVIEW'}
      quiz_key={quiz_key}
      quizBlueprint={_zzsurvey_utils_quizEditorState_to_quizBlueprint_preview({
        title: 'Fake title',
        survey_text: 'Fake text',
        survey_img_src: null,
        // date_due: '2030-12-31',
        service_type: 'Web design',
      }, [])}
      cbSubmit={(quiz_key, entbox) => {
        // window.alert('TODO');
        // const quiz_key = state.quiz_key;
        // fetchSubmitFillSurvey(quiz_key, entbox);
        // FAKE SUCCESS
        setState({
          ...state,
          fetchingSubmit: false,
          error: null,
          thank_you: true,
        });
      }}
    />
  );
  */

  return (
    <div className="zzsurvey__layout-page-wrapper zzsurvey__layout-page-wrapper--public this-is-quiz-fill-page">
      {
        detected_env === 'DEV' && (
          <div className="zzsurvey-app__env">DEV ENVIRONMENT</div>
        )
      }
      {
        detected_env === 'STG' && (
          <div className="zzsurvey-app__env">STG ENVIRONMENT FOR TESTING</div>
        )
      }
      {jsxTestFakeQuiz}
      {
        state.fetching === false ? (
          state.backendQuizBlueprint ? (
            <ZZTempSurveyQuizFill
              mode={'REAL'}
              quiz_key={quiz_key}
              quizBlueprint={_zzsurvey_utils_backendQuizBlueprint_to_quizBlueprint(state.backendQuizBlueprint)}
              cbSubmit={(quiz_key, entbox) => {
                // window.alert('TODO');
                // const quiz_key = state.quiz_key;
                fetchSubmitFillSurvey(quiz_key, entbox);
              }}
            />
          ) : (
            <>
              <div className="flex-1"></div>
              <div className="zzsurvey__landing-content">
                <div className="zzsurvey__pad-16px">
                  <p className="zzsurvey__error-user-friendly">{state.error}</p>
                </div>
              </div>
              <div className="flex-3"></div>
            </>
          )
        ) : (
          <>
            <div className="flex-1"></div>
            <div className="zzsurvey__landing-content">
              <div>{jsxSpinner}</div>
              <div className="zzsurvey__dev-only">DEBUG quiz key: <JSDisplayValue val={quiz_key} /></div>
            </div>
            <div className="flex-2"></div>
          </>
        )
      }
    </div>
  );
};


const TABLE_CLIENTS = "TABLE_CLIENTS";
const TABLE_CLIENTS_OF_SELLER = "TABLE_CLIENTS_OF_SELLER"; // NEW
const TABLE_SELLERS = "TABLE_SELLERS"; // NEW
const TABLE_CUSTOMERS = "TABLE_CUSTOMERS";
const TABLE_TEMPLATES = "TABLE_TEMPLATES";
const TABLE_INSTANCES = "TABLE_INSTANCES";
const TABLE_INSTANCES_FILLED = "TABLE_INSTANCES_FILLED";
const TABLE_GOOGLE_REVIEWS = "TABLE_GOOGLE_REVIEWS";
const TABLE_CDP_CUSTOMERS = "TABLE_CDP_CUSTOMERS";
const TABLE_CONSENTS = "TABLE_CONSENTS";
const TABLE_SIGNATURES = "TABLE_SIGNATURES";
const initialAppState = {
  // freshness: 0,
  freshness: 1,
  url_path: '',
  detected_env: null,
  routeSimple: {
    route: 'HOME',
    // title: 'Početna',
    // breadcrumbs: [],
    route_params: {},
    freshness: 0
  },
  ulogovan: false,
  my_user_data: {},
  token: null,
  quiz_key: null,
  client_id: null, // TODO
  superadmin_selected_client_id: null, // TODO
  seller_selected_client_id: null, // TODO
  // seller_selected_client_id: 1, // TODO
  seller_selected_multiple_ccustomer_ids: [], // TODO
  customers_filter: '',
  customers_filter_2: '',
  seller_route: 'HOME', // HOME(DASHBOARD) DEMO CUSTOMERS TEMPLATES INSTANCES
  google_reviews_api_key: null,
  google_reviews_place_id: null,
  google_reviews_form_link: null,
  fetchingSubmit: false,
  tables_data: {
    "TABLE_CLIENTS": {
      type_is_arr: true,
      fatching: false,
      /*
      data: [
        {
          id: 1,
          email: 'e',
        },
        {
          id: 2,
          email: 'ee',
        },
        {
          id: 3,
          email: 'eee',
        }
      ],
      */
      data: [],
    },
    "TABLE_CLIENTS_OF_SELLER": {
      type_is_arr: true,
      fatching: false,
      data: [],
    },
    "TABLE_SELLERS": {
      type_is_arr: true,
      fatching: false,
      data: [],
    },
    "TABLE_CUSTOMERS": {
      type_is_arr: true,
      fatching: false,
      data: [],
    },
    "TABLE_TEMPLATES": {
      type_is_arr: true,
      fatching: false,
      data: [],
    },
    "TABLE_INSTANCES": {
      type_is_arr: true,
      fatching: false,
      data: [],
    },
    "TABLE_INSTANCES_FILLED": {
      type_is_arr: true,
      fatching: false,
      data: [],
    },
    "TABLE_GOOGLE_REVIEWS": {
      type_is_arr: true,
      fatching: false,
      data: [],
    },
    "TABLE_CDP_CUSTOMERS": {
      type_is_arr: true,
      fatching: false,
      data: [],
      // data: [{}, {}],
    },
    "TABLE_CONSENTS": {
      type_is_arr: true,
      fatching: false,
      data: [],
    },
    "TABLE_SIGNATURES": {
      type_is_arr: true,
      fatching: false,
      data: [],
    },
  },
};

// TODO
const _extract_single_table_state = (state, view_key) => {
  return state.tables_data[view_key];
};


const _zzsurvey_router_helper = (url_path, url_query) => {
  console.log('route helper url_path', url_path);
  let route = 'NOT_FOUND';
  let route_params = {};
  let quiz_key = null;
  if (typeof url_path === 'string') {
    if (url_path === '/') {
      route = 'HOME';
    } else if (url_path.indexOf('/survey') === 0) {
      console.log('route contain /survey/');
      route = 'QUIZ_FILL';
      if (url_path.indexOf('/survey/') === 0) {
        quiz_key = url_path.split('/')[2]; // ['', 'survey', 'abcdef']
        console.log('router detected quiz_key', quiz_key);
      }
    } else if (url_path.indexOf('/admin') === 0) {
      const url_path_exploded = url_path.split('/');
      if (url_path_exploded[1] === 'admin') {
        route = 'DASHBOARD';
        //
        // if (url_path_exploded[2] === 'sign') {
      }
    } else if (url_path.indexOf('/dev') === 0) {
      const url_path_exploded = url_path.split('/');
      if (url_path_exploded[1] === 'dev') {
        route = 'DEVPANEL';
      }
    } else if (url_path.indexOf('/signatures') === 0) {
      // if (url_path_exploded[2] === 'sign') {
      route = 'SIGN_CONSENT';
      route_params = {};
      if (typeof url_query === 'string') {
        const paramsString = url_query;
        // https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams
        const searchParams = new URLSearchParams(paramsString);
        console.log('searchParams', searchParams.toString());
        if (searchParams.has("cdp_sifra")) {
          route_params.token_from_signature_url = searchParams.get("cdp_sifra");
          console.log('router detected token_from_signature_url', route_params.token_from_signature_url);
        }
        if (searchParams.has("cdp_sifra")) {
          route_params.cdp_sifra = searchParams.get("cdp_sifra");
          console.log('router detected cdp_sifra', route_params.cdp_sifra);
        }
        if (searchParams.has("cdp_customer_id")) {
          route_params.cdp_customer_id = searchParams.get("cdp_customer_id");
          console.log('router detected cdp_customer_id', route_params.cdp_customer_id);
        }
        if (searchParams.has("consent_id")) {
          route_params.consent_id = searchParams.get("consent_id");
          console.log('router detected consent_id', route_params.consent_id);
        }
      }
      // }
    }
  }
  //
  return {
    route,
    quiz_key,
    route_params,
  }
};


// DEFAULT COMPONNENT
const ZZTempSurvey = (props) => {
  console.log('app_build_version_id', app_build_version_id_zzsurveyapp);
  const dispatch = useDispatch();
  const { dispatchShowToast, dispatchShowModal } = useModal();
  // const dispatchShowToast = dispatchShowToastMobile;
  const [appState, setAppState] = useState(initialAppState);
  // const [modalPortableOpened, setModalPortableOpened] = useState(false);
  const [modalPortableContent, setModalPortableContent] = useState(false); // false or modalContent

  const [sidebarOpened, setSidebarOpened] = useState(false);
  const setSellerRoute = (seller_route) => {
    setAppState(appState => {
      return {
        ...appState,
        seller_route: seller_route,
      }
    });
    setSidebarOpened(false);
  };

  //
  const {
    csvInputVal, arrayOfObjectsFromCsv, csvEditorWidgetPack
  } = useCsvEditorWidget('', ',');


  const detected_env = appState.detected_env;
  const route = appState.routeSimple.route;
  const seller_route = appState.seller_route;
  let seller_selected_client_id = "";
  if (appState.seller_selected_client_id > 0) {
    seller_selected_client_id = appState.seller_selected_client_id;
  }
  console.log('route', route);
  let is_superadmin = false;
  let is_seller = false;
  if (appState.ulogovan === true && appState.my_user_data?.role === 'superadmin') {
    is_superadmin = true;
  } else {
    is_seller = true;
  }

  let clients_of_seller = _extract_single_table_state(appState, TABLE_CLIENTS_OF_SELLER).data;
  let _clients_of_seller_obj = {};
  let _options_clients_of_seller = [
    {
      "title": "--select client--",
      "value": "",
    }
  ];
  if (Array.isArray(clients_of_seller)) {
    // _options_clients_of_seller = clients_of_seller.map((item) => {
    _options_clients_of_seller = [];
    clients_of_seller.forEach((item) => {
      _options_clients_of_seller.push({
        "title": item.name,
        "value": item.client_id,
      });
      _clients_of_seller_obj[item.client_id] = { ...item };
    });
  }
  //


  /*
  google_reviews_api_key: null,
  google_reviews_place_id: null,
  google_reviews_form_link: null,
  */
  const google_reviews_arr = _extract_single_table_state(appState, TABLE_GOOGLE_REVIEWS).data;
  const google_reviews_fetching = _extract_single_table_state(appState, TABLE_GOOGLE_REVIEWS).fetching;
  const google_reviews_form_link = appState.google_reviews_form_link;


  // customers_filtered_arr
  let customers_filtered_arr = [];


  // alerts
  let alerts_survey_instance_arr = [];
  const customers_arr = _extract_single_table_state(appState, TABLE_CUSTOMERS).data;
  const customers_fetching = _extract_single_table_state(appState, TABLE_CUSTOMERS).fetching;
  let alerts_survey_instance_id_arr = [];
  if (customers_fetching === true) {
  } else {
    //
    const customers_filter = appState.customers_filter;
    const customers_filter_2 = appState.customers_filter_2;
    customers_filtered_arr = customers_arr.filter((item) => {
      // let in = true;
      if (customers_filter !== '') {
        if (customers_filter === 'PRODAJA_I_SERVIS') {
          if (js_utils.is_string_not_empty(item.last_sales_date) && js_utils.is_string_not_empty(item.last_service_date)) {
            // return true;
          } else {
            return false;
          }
        } else if (customers_filter === 'PRODAJA') {
          if (js_utils.is_string_not_empty(item.last_sales_date)) {
            // return true;
          } else {
            return false;
          }
        } else if (customers_filter === 'SERVIS') {
          if (js_utils.is_string_not_empty(item.last_service_date)) {
            // return true;
          } else {
            return false;
          }
        }
      } else { // CASE NO FILTER
        // return true;
      }
      if (customers_filter_2 !== '') {
        if (customers_filter_2 === 'POPUNJENE') {
          if (item.filled_surveys_count > 0) {
            // return true;
          } else {
            return false;
          }
        } else if (customers_filter_2 === 'NA_CEKANJU') {
          if (item.pending_surveys_count > 0) {
            // return true;
          } else {
            return false;
          }
        } else if (customers_filter_2 === 'ISTEKLE') {
          if (item.expired_surveys_count > 0) {
            // return true;
          } else {
            return false;
          }
        }
      } else { // CASE NO FILTER
        // return true;
      }
      return true;
    });
    //
    customers_arr.forEach((item) => {
      if (item.low_ratings && Array.isArray(item.low_ratings)) {
        item.low_ratings.forEach((instance) => {
          if (instance && instance.survey_instance_id) {
            alerts_survey_instance_id_arr.push(instance.survey_instance_id);
          }
        });
      }
    });
  }
  const instances_for_alerts_arr = _extract_single_table_state(appState, TABLE_INSTANCES_FILLED).data;
  const instances_for_alerts_fetching = _extract_single_table_state(appState, TABLE_INSTANCES_FILLED).fetching;
  if (instances_for_alerts_fetching === true) {
  } else {
    alerts_survey_instance_arr = instances_for_alerts_arr.filter((item) => {
      if (item && item.survey_instance_id && alerts_survey_instance_id_arr.includes(item.survey_instance_id)) {
        return true; // stay in array
      }
      return false; // all other deleted
    });
  }


  //
  let signatures_arr = [];
  const cdp_customers_for_signatures_arr = _extract_single_table_state(appState, TABLE_SIGNATURES).data;
  const cdp_customers_for_signatures_fetching = _extract_single_table_state(appState, TABLE_SIGNATURES).fetvhing;
  if (cdp_customers_for_signatures_fetching === true) {
  } else {
    cdp_customers_for_signatures_arr.forEach((item) => {
      const cdp_customer_obj = {
        cdp_sifra: item.cdp_sifra,
        email: item.email,
        location: item.location,
      };
      if (item && Array.isArray(item.signatures)) {
        item.signatures.forEach((s) => {
          const signature_obj = {
            signature_id: s.signature_id,
            accepts_terms: s.accepts_terms,
            date_created: s.date_created,
            signature_url: s.signature_url,
            consent_id: s.consent.consent_id,
            internal_name: s.consent.internal_name,
          };
          signatures_arr.push({
            ...cdp_customer_obj,
            ...signature_obj,
          });
        });
      }
    });
  }


  //
  //
  const _popuniPutemCsv = () => {
    const csv = csvInputVal;
    if (typeof csv === 'string') {
      // console.log('csv', csv);
      // const array_of_objects = csv_utils_csv_to_array_of_objects(csv, csvSeparator);
      const array_of_objects = arrayOfObjectsFromCsv;
      console.log('csv to array_of_objects', array_of_objects);
      //
      let _customers_for_import = [];
      array_of_objects.forEach((row_obj, index) => {
        let email = row_obj.email;
        if (typeof row_obj.email === 'string') {
          email = row_obj.email.trim().toLowerCase()
        }
        const s = {
          name: js_utils.string_trim_smart(row_obj.name),
          // surname: js_utils.string_trim_smart(row_obj.surname),
          email: email,
          // client_id: row_obj.client_id,
          phone: typeof row_obj.phone === 'string' ? row_obj.phone : '',
          location: typeof row_obj.location === 'string' ? row_obj.location : '',
          cdp_sifra: typeof row_obj.cdp_sifra === 'string' ? row_obj.cdp_sifra : '',
        };
        _customers_for_import.push(s);
      });
      //
      //
      // SUMBIT import customers
      const data = {
        client_id: seller_selected_client_id,
        customers: _customers_for_import,
      };
      console.log('...importing customers data:', data);
      // STEP 1 spinner
      setFetchingSubmit(true);
      // STEP 2 fetching
      _zzsurvey_ajax.importCustomers(data)
        .then(response => {
          console.log(view_key, 'response', response);
          // STEP 3 fetched
          setFetchingSubmit(false);
          // setModalPortableContent(false);
          const view_key = TABLE_CUSTOMERS;
          fetchListUniversal(view_key);
        })
        .catch(err => {
          // STEP 3b FAIL
          console.log('CATCH error after axios', err);
          error_msg_handle(err);
          setFetchingSubmit(false);
        })

    }
  };
  //
  //
  const _popuniPutemCsv_CdpCustomers = () => {
    const csv = csvInputVal;
    if (typeof csv === 'string') {
      // console.log('csv', csv);
      // const array_of_objects = csv_utils_csv_to_array_of_objects(csv, csvSeparator);
      const array_of_objects = arrayOfObjectsFromCsv;
      console.log('csv to array_of_objects', array_of_objects);
      //
      let _customers_for_import = [];
      array_of_objects.forEach((row_obj, index) => {
        let email = row_obj.email;
        if (typeof row_obj.email === 'string') {
          email = row_obj.email.trim().toLowerCase()
        }
        const s = {
          name: js_utils.string_trim_smart(row_obj.name),
          // surname: js_utils.string_trim_smart(row_obj.surname),
          email: email,
          // client_id: row_obj.client_id,
          phone: typeof row_obj.phone === 'string' ? row_obj.phone : '',
          location: typeof row_obj.location === 'string' ? row_obj.location : '',
          cdp_sifra: typeof row_obj.cdp_sifra === 'string' ? row_obj.cdp_sifra : '',
        };
        _customers_for_import.push(s);
      });
      //
      //
      // SUMBIT import cdp_customers
      const data = {
        client_id: seller_selected_client_id,
        cdp_customers: _customers_for_import,
      };
      console.log('...importing cdp_customers data:', data);
      // STEP 1 spinner
      setFetchingSubmit(true);
      // STEP 2 fetching
      _zzsurvey_ajax.importCdpCustomers(data)
        .then(response => {
          console.log(view_key, 'response', response);
          // STEP 3 fetched
          setFetchingSubmit(false);
          // setModalPortableContent(false);
          const view_key = TABLE_CDP_CUSTOMERS;
          fetchListUniversal(view_key);
        })
        .catch(err => {
          // STEP 3b FAIL
          console.log('CATCH error after axios', err);
          error_msg_handle(err);
          setFetchingSubmit(false);
        })

    }
  };
  //
  //


  // const [apiUrlPrefix, setApiUrlPrefix] = useState('http://localhost:3001');

  useEffect(() => { // component did mount AUTO LOGIN
    //
    //
    (async () => {
      //
      // --- AUTH procedure autologin by token 
      const _local_token = await window.localStorage.getItem(config_TOKEN_LOCAL_KEY);
      console.log('_local_token', _local_token);
      _zzsurvey_authUtils.setToken(_local_token);
      if (typeof _local_token === 'string' && _local_token !== '') {
        console.log('*** will do AUTOLOGIN BY TOKEN');
        _zzsurvey_ajax.loginbytoken()
          .then((response) => {
            console.log('autologin response', response);
            if (response?.data?.token) {
              let client_id = null;
              if (response.data?.user?.client) {
                client_id = response.data.user.client.client_id;
              }
              let clients_of_seller = [];
              if (response.data?.user?.role === "seller") {
                if (Array.isArray(response.data?.clients)) {
                  clients_of_seller = response.data.clients;
                }
              }
              setAppState(state => {
                return {
                  ...state,
                  ulogovan: true,
                  token: response.data.token,
                  my_user_data: response.data.user,
                  client_id: client_id,
                  google_reviews_api_key: null,
                  google_reviews_place_id: null,
                  google_reviews_form_link: null,
                  freshness: state.freshness + 1,
                  tables_data: {
                    ...state.tables_data,
                    [TABLE_CLIENTS_OF_SELLER]: {
                      ...state.tables_data[TABLE_CLIENTS_OF_SELLER],
                      data: clients_of_seller,
                    }
                  },
                }
              });
              setModalPortableContent(false);
              //
              // --- AUTH procedure after autologin success
              const _token_val = response.data.token;
              _zzsurvey_authUtils.setToken(_token_val);
              window.localStorage.setItem(config_TOKEN_LOCAL_KEY, _token_val); // write to local storage
              //
              //
            } else {
              // dispatchShowToast('ERROR No token!', 'RED');
              console.log('*** error no token in response');
            }
            setFetchingSubmit(false);
          })
          .catch(err => {
            console.log('CATCH error after axios loginbytoken()', err);
            // error_msg_handle(err);
          })

      } else {
        console.log('*** no local token - skip AUTOLOGIN');
      }
    })();
    //
    //
  }, []);


  /*
  useEffect(() => {
    //
    //
    if (typeof appState.token === 'string') { // CASE after login
      _zzsurvey_ajax.loginbytoken()
        .then((response) => {
          console.log('login response', response);
          if (response?.data?.token) {
            let client_id = null;
            if (response.data?.user?.client) {
              client_id = response.data.user.client.client_id;
            }
            setAppState(state => {
              return {
                ...state,
                ulogovan: true,
                token: response.data.token,
                my_user_data: response.data.user,
                client_id: client_id,
                freshness: state.freshness + 1,
              }
            });
            setModalPortableContent(false);
          } else {
            dispatchShowToast('ERROR No token!', 'RED');
          }
          setFetchingSubmit(false);
        })
        .catch(err => {

          console.log('CATCH error after axios', err);
          error_msg_handle(err);
        })
    } else { // CASE before login

    }
    //
    // --- AUTH procedure after form login
    let _token_val = 'NONE';
    if (typeof appState.token === 'string') {
      _token_val = appState.token;
    }
    _zzsurvey_authUtils.setToken(_token_val);
    window.localStorage.setItem(config_TOKEN_LOCAL_KEY, _token_val); // write to local storage
    //
    //
  }, [appState.token]);
  */


  useEffect(() => {
    if (is_superadmin) {
      document.body.classList.remove('theme-seller2025');
      document.body.classList.add('theme-superadmin2025');
    } else {
      document.body.classList.remove('theme-superadmin2025');
      document.body.classList.add('theme-seller2025');
    }
    setAppState(appState => {
      return {
        ...appState,
        seller_route: 'HOME'
      };
    });
  }, [is_superadmin, is_seller]);

  const url = window.location;
  useEffect(() => {
    console.log('useEffect url', url);
    const url_path = window.location.pathname;
    const url_host = window.location.host;
    const url_query = window.location.search // to get the query portion of the URL
    let detected_env = null;
    if (url_host === 'stg.ratemyservice.rs') {
      detected_env = 'STG';
    } else if (url_host === 'dev.ratemyservice.rs') {
      detected_env = 'DEV';
    }
    const _route = _zzsurvey_router_helper(url_path, url_query);
    console.log('_route', _route);
    setAppState({
      ...appState,
      url_path: url_path,
      detected_env: detected_env,
      routeSimple: {
        // route: 'HOME',
        route: _route.route,
        // title: 'Početna',
        // breadcrumbs: [],
        // route_params: {},
        route_params: _route.route_params,
        freshness: 0
      },
      quiz_key: _route.quiz_key,
    });
    browser_utils.browser_title_set('RateMyService portal');
  }, [url]);

  const info = {
    url_full: window.location.href,
    url_port: window.location.port,
    url_path: window.location.pathname,
    url_query: window.location.search,
    url_fragment: window.location.hash,
    freshness: appState.freshness,
    api_url_prefix: _zzsurvey_urlLib.websitePrefix(),
    ulogovan: appState.ulogovan,
    token: _zzsurvey_authUtils.getToken(),
    client_id: appState.client_id,
    route: route,
    quiz_key: appState.quiz_key,
  };

  const error_msg_handle = (err) => {
    let error_msg = 'Error!';
    if (err?.response?.data?.error === "jwt expired") {
      error_msg = 'You must login again!';
    } else {
      console.log(err?.response?.data?.error);
      console.log(err?.response?.data?.error?.type);
      if (err?.response?.data?.error?.type === "field") {
        error_msg = err.response.data.error.msg;
      } else {
        if (typeof err?.response?.data?.message === 'string') {
          error_msg = err.response.data.message;
        } else {
          if (err?.response?.status === 404) {
            error_msg = '404 API route not found';
          }
        }
      }
    }
    dispatchShowToast(error_msg, 'RED');
  };


  //
  const _handleMultipleCustomersSelectionChange = (selected_multiple_ccustomer_ids) => {
    if (Array.isArray(selected_multiple_ccustomer_ids)) {
      console.log('_handleMultipleCustomersSelectionChange', selected_multiple_ccustomer_ids);
      setAppState(state => {
        return {
          ...state,
          seller_selected_multiple_ccustomer_ids: [...selected_multiple_ccustomer_ids],
          freshness: state.freshness + 1,
        };
      });
    } else {
      setAppState(state => {
        return {
          ...state,
          seller_selected_multiple_ccustomer_ids: [],
          freshness: state.freshness + 1,
        };
      });
    }
  };

  //
  const _fresh = () => {
    setAppState(state => {
      return {
        ...state,
        freshness: state.freshness + 1,
      };
    });
  };

  const setFetchingSubmit = (is) => {
    setAppState(state => {
      return {
        ...state,
        fetchingSubmit: is,
      }
    });
  };

  //
  const fetchListUniversal = (view_key, payload) => {
    if (view_key === TABLE_CLIENTS) {
      // _extract_single_table_state = (state, view_key)
      setAppState(state => {
        const updatedState = { ...state };
        updatedState.tables_data[view_key] = {
          ...updatedState.tables_data[view_key],
          fetching: true,
        };
        return updatedState;
      });
      _zzsurvey_ajax.getAllClients()
        .then(response => {
          console.log(view_key, 'response', response);
          if (Array.isArray(response?.data?.clients)) {
            setAppState(state => {
              const updatedState = { ...state };
              updatedState.tables_data[view_key] = {
                ...updatedState.tables_data[view_key],
                fetching: false,
                data: response.data.clients,
              };
              return updatedState;
            });
            _fresh();
          }
        })
        .catch(err => {
          setAppState(state => {
            const updatedState = { ...state };
            updatedState.tables_data[view_key] = {
              ...updatedState.tables_data[view_key],
              fetching: false,
              data: [],
            };
            return updatedState;
          });
          console.log('CATCH error after axios', err);
          error_msg_handle(err);
          _fresh();
        })

    } else if (view_key === TABLE_SELLERS) {
      setAppState(state => {
        const updatedState = { ...state };
        updatedState.tables_data[view_key] = {
          ...updatedState.tables_data[view_key],
          fetching: true,
        };
        return updatedState;
      });
      const client_id = payload.client_id;
      // _zzsurvey_ajax.getAllSellersOfClient(client_id) // TODO
      // sada fetchujemo sve sellere nevezano za klienta
      _zzsurvey_ajax.getAllSellers()
        .then(response => {
          console.log(view_key, 'response', response);
          if (Array.isArray(response?.data?.sellers)) {
            setAppState(state => {
              const updatedState = { ...state };
              updatedState.tables_data[view_key] = {
                ...updatedState.tables_data[view_key],
                fetching: false,
                data: response.data.sellers,
              };
              return updatedState;
            });
            _fresh();
          }
        })
        .catch(err => {
          setAppState(state => {
            const updatedState = { ...state };
            updatedState.tables_data[view_key] = {
              ...updatedState.tables_data[view_key],
              fetching: false,
              data: [],
            };
            return updatedState;
          });
          console.log('CATCH error after axios', err);
          error_msg_handle(err);
          _fresh();
        })

    } else if (view_key === TABLE_CUSTOMERS) {
      setAppState(state => {
        const updatedState = { ...state };
        updatedState.tables_data[view_key] = {
          ...updatedState.tables_data[view_key],
          fetching: true,
        };
        return updatedState;
      });
      _zzsurvey_ajax.getAllCustomersOfClient(seller_selected_client_id)
        .then(response => {
          console.log(view_key, 'response', response);
          if (Array.isArray(response?.data?.customers)) {
            setAppState(state => {
              const updatedState = { ...state };
              updatedState.tables_data[view_key] = {
                ...updatedState.tables_data[view_key],
                fetching: false,
                data: response.data.customers,
              };
              return updatedState;
            });
            _fresh();
          }
        })
        .catch(err => {
          setAppState(state => {
            const updatedState = { ...state };
            updatedState.tables_data[view_key] = {
              ...updatedState.tables_data[view_key],
              fetching: false,
              data: [],
            };
            return updatedState;
          });
          console.log('CATCH error after axios', err);
          error_msg_handle(err);
          _fresh();
        })

    } else if (view_key === TABLE_TEMPLATES) {
      setAppState(state => {
        const updatedState = { ...state };
        updatedState.tables_data[view_key] = {
          ...updatedState.tables_data[view_key],
          fetching: true,
        };
        return updatedState;
      });
      _zzsurvey_ajax.getAllSurveyTemplatesOfClient(seller_selected_client_id)
        .then(response => {
          console.log(view_key, 'response', response);
          if (Array.isArray(response?.data?.surveys)) {
            setAppState(state => {
              const updatedState = { ...state };
              updatedState.tables_data[view_key] = {
                ...updatedState.tables_data[view_key],
                fetching: false,
                data: response.data.surveys,
              };
              return updatedState;
            });
            _fresh();
          }
          dispatch({ type: 'GLOBAL_FRESHNESS_UPDATE' });
        })
        .catch(err => {
          console.log(err);
          setAppState(state => {
            const updatedState = { ...state };
            updatedState.tables_data[view_key] = {
              ...updatedState.tables_data[view_key],
              fetching: false,
              data: [],
            };
            return updatedState;
          });
          console.log('CATCH error after axios', err);
          error_msg_handle(err);
          dispatch({ type: 'GLOBAL_FRESHNESS_UPDATE' });
          _fresh();
        })
    } else if (view_key === TABLE_INSTANCES) {
      setAppState(state => {
        const updatedState = { ...state };
        updatedState.tables_data[view_key] = {
          ...updatedState.tables_data[view_key],
          fetching: true,
        };
        return updatedState;
      });
      _zzsurvey_ajax.getAllSurveyInstancesOfClient('', seller_selected_client_id)
        .then(response => {
          console.log(view_key, 'response', response);
          if (Array.isArray(response?.data?.surveys)) {
            setAppState(state => {
              const updatedState = { ...state };
              updatedState.tables_data[view_key] = {
                ...updatedState.tables_data[view_key],
                fetching: false,
                data: response.data.surveys,
              };
              return updatedState;
            });
          }
        })
        .catch(err => {
          setAppState(state => {
            const updatedState = { ...state };
            updatedState.tables_data[view_key] = {
              ...updatedState.tables_data[view_key],
              fetching: false,
              data: [],
            };
            return updatedState;
          });
          console.log('CATCH error after axios', err);
          error_msg_handle(err);
        })
      //
      // also fetch TABLE_INSTANCES_FILLED
      console.log('fetching TABLE_INSTANCES_FILLED ...');
      const _view_key_2 = 'TABLE_INSTANCES_FILLED';
      setAppState(state => {
        const updatedState = { ...state };
        updatedState.tables_data[_view_key_2] = {
          ...updatedState.tables_data[_view_key_2],
          fetching: true,
        };
        return updatedState;
      });
      _zzsurvey_ajax.getAllSurveyInstancesOfClient('filled', seller_selected_client_id)
        .then(response => {
          console.log(_view_key_2, 'response', response);
          if (Array.isArray(response?.data?.surveys)) {
            setAppState(state => {
              const updatedState = { ...state };
              updatedState.tables_data[_view_key_2] = {
                ...updatedState.tables_data[_view_key_2],
                fetching: false,
                data: response.data.surveys,
              };
              return updatedState;
            });
          }
        })
        .catch(err => {
          setAppState(state => {
            const updatedState = { ...state };
            updatedState.tables_data[_view_key_2] = {
              ...updatedState.tables_data[_view_key_2],
              fetching: false,
              data: [],
            };
            return updatedState;
          });
          console.log('CATCH error after axios', err);
          error_msg_handle(err);
        })
    } else if (view_key === TABLE_GOOGLE_REVIEWS) {
      // const { api_key, place_id } = payload;
      const api_key = appState.google_reviews_api_key;
      const place_id = appState.google_reviews_place_id;
      setAppState(state => {
        const updatedState = {
          ...state,
          google_reviews_form_link: null,
        };
        updatedState.tables_data[view_key] = {
          ...updatedState.tables_data[view_key],
          fetching: true,
        };
        return updatedState;
      });
      _zzsurvey_ajax.getAllReviews({ api_key, place_id, client_id: appState.seller_selected_client_id })
        .then(response => {
          console.log(view_key, 'response', response);
          if (Array.isArray(response?.data?.reviews)) {
            let google_reviews_form_link = null;
            if (typeof response?.data?.reviewFormLink) {
              google_reviews_form_link = response.data.reviewFormLink;
            }
            setAppState(state => {
              const updatedState = {
                ...state,
                google_reviews_form_link,
              };
              updatedState.tables_data[view_key] = {
                ...updatedState.tables_data[view_key],
                fetching: false,
                data: response.data.reviews,
              };
              return updatedState;
            });
          }
        })
        .catch(err => {
          setAppState(state => {
            const updatedState = { ...state };
            updatedState.tables_data[view_key] = {
              ...updatedState.tables_data[view_key],
              fetching: false,
              data: [],
            };
            return updatedState;
          });
          console.log('CATCH error after axios', err);
          error_msg_handle(err);
        })
      //
    } else if (view_key === TABLE_CDP_CUSTOMERS) {
      setAppState(state => {
        const updatedState = { ...state };
        updatedState.tables_data[view_key] = {
          ...updatedState.tables_data[view_key],
          fetching: true,
        };
        return updatedState;
      });
      _zzsurvey_ajax.getAllCdpCustomersOfClient(seller_selected_client_id)
        .then(response => {
          console.log(view_key, 'response', response);
          if (Array.isArray(response?.data?.cdp_customers)) {
            setAppState(state => {
              const updatedState = { ...state };
              updatedState.tables_data[view_key] = {
                ...updatedState.tables_data[view_key],
                fetching: false,
                data: response.data.cdp_customers,
              };
              return updatedState;
            });
            _fresh();
          }
        })
        .catch(err => {
          setAppState(state => {
            const updatedState = { ...state };
            updatedState.tables_data[view_key] = {
              ...updatedState.tables_data[view_key],
              fetching: false,
              data: [],
              // data: [{}, {}],
            };
            return updatedState;
          });
          console.log('CATCH error after axios', err);
          error_msg_handle(err);
          _fresh();
        })
    } else if (view_key === TABLE_CONSENTS) {
      setAppState(state => {
        const updatedState = { ...state };
        updatedState.tables_data[view_key] = {
          ...updatedState.tables_data[view_key],
          fetching: true,
        };
        return updatedState;
      });
      _zzsurvey_ajax.getAllConsentsOfClient(seller_selected_client_id)
        .then(response => {
          console.log(view_key, 'response', response);
          if (Array.isArray(response?.data?.consents)) {
            setAppState(state => {
              const updatedState = { ...state };
              updatedState.tables_data[view_key] = {
                ...updatedState.tables_data[view_key],
                fetching: false,
                data: response.data.consents,
              };
              return updatedState;
            });
            _fresh();
          }
        })
        .catch(err => {
          setAppState(state => {
            const updatedState = { ...state };
            updatedState.tables_data[view_key] = {
              ...updatedState.tables_data[view_key],
              fetching: false,
              data: [],
              // data: [{}, {}],
            };
            return updatedState;
          });
          console.log('CATCH error after axios', err);
          error_msg_handle(err);
          _fresh();
        })
    } else if (view_key === TABLE_SIGNATURES) {
      setAppState(state => {
        const updatedState = { ...state };
        updatedState.tables_data[view_key] = {
          ...updatedState.tables_data[view_key],
          fetching: true,
        };
        return updatedState;
      });
      _zzsurvey_ajax.getAllSignaturesOfClient(seller_selected_client_id)
        .then(response => {
          console.log(view_key, 'response', response);
          if (Array.isArray(response?.data?.cdp_customers)) {
            setAppState(state => {
              const updatedState = { ...state };
              updatedState.tables_data[view_key] = {
                ...updatedState.tables_data[view_key],
                fetching: false,
                data: response.data.cdp_customers,
              };
              return updatedState;
            });
            _fresh();
          }
        })
        .catch(err => {
          setAppState(state => {
            const updatedState = { ...state };
            updatedState.tables_data[view_key] = {
              ...updatedState.tables_data[view_key],
              fetching: false,
              data: [],
              // data: [{}, {}],
            };
            return updatedState;
          });
          console.log('CATCH error after axios', err);
          error_msg_handle(err);
          _fresh();
        })

    }
  };


  //
  useEffect(() => {
    if (appState.superadmin_selected_client_id) {
      fetchListUniversal(TABLE_SELLERS, { slient_id: appState.superadmin_selected_client_id });
    }
  }, [appState.superadmin_selected_client_id]);


  //
  /*
  useEffect(() => {
    if (appState.ulogovan === true && appState.google_reviews_api_key && appState.google_reviews_place_id) {
      fetchListUniversal(TABLE_GOOGLE_REVIEWS, {
        api_key: appState.google_reviews_api_key,
        place_id: appState.google_reviews_place_id,
      });
    }
  }, [appState.google_reviews_api_key, appState.google_reviews_place_id, appState.ulogovan]);
  */


  //
  const fetchCreateUniversal = (view_key, entity) => {
    if (view_key === TABLE_CLIENTS) {
      // STEP 1 spinner
      setFetchingSubmit(true);
      // STEP 2 fetching
      _zzsurvey_ajax.createClient(entity)
        .then(response => {
          console.log(view_key, 'response', response);
          // STEP 3 fetched
          setFetchingSubmit(false);
          setModalPortableContent(false);
          fetchListUniversal(view_key);
        })
        .catch(err => {
          // STEP 3b FAIL
          console.log('CATCH error after axios', err);
          error_msg_handle(err);
          setFetchingSubmit(false);
        })
    } else if (view_key === TABLE_CUSTOMERS) {
      // STEP 1 spinner
      setFetchingSubmit(true);
      // STEP 2 fetching
      _zzsurvey_ajax.createCustomer({ ...entity, client_id: seller_selected_client_id })
        .then(response => {
          console.log(view_key, 'response', response);
          // STEP 3 fetched
          setFetchingSubmit(false);
          setModalPortableContent(false);
          fetchListUniversal(view_key);
        })
        .catch(err => {
          // STEP 3b FAIL
          console.log('CATCH error after axios', err);
          error_msg_handle(err);
          setFetchingSubmit(false);
        })
    } else if (view_key === TABLE_TEMPLATES) { // TODO
      // STEP 1 spinner
      setFetchingSubmit(true);
      // STEP 2 fetching
      _zzsurvey_ajax.createSurveyTemplate({ ...entity, client_id: seller_selected_client_id })
        .then(response => {
          console.log(view_key, 'response', response);
          // STEP 3 fetched
          setFetchingSubmit(false);
          setModalPortableContent(false);
          fetchListUniversal(view_key);
        })
        .catch(err => {
          // STEP 3b FAIL
          console.log('CATCH error after axios', err);
          error_msg_handle(err);
          setFetchingSubmit(false);
        })
    } else if (view_key === TABLE_INSTANCES) {
      // STEP 1 spinner
      setFetchingSubmit(true);
      // STEP 2 fetching
      _zzsurvey_ajax.createSurveyInstance(entity)
        .then(response => {
          console.log('createSurveyInstance response', response);
          // TODO nema pokazatelja da je uspašan update
          setFetchingSubmit(false);
          setAppState(appState => {
            return {
              ...appState,
              seller_selected_multiple_ccustomer_ids: [], // RESET TODO
            };
          });
          setModalPortableContent(false);
          fetchListUniversal(view_key);
        })
        .catch(err => {
          // STEP 3b FAIL
          console.log('CATCH error after axios', err);
          error_msg_handle(err);
          setFetchingSubmit(false);
        })
    } else if (view_key === TABLE_CDP_CUSTOMERS) {
      // STEP 1 spinner
      setFetchingSubmit(true);
      // STEP 2 fetching
      _zzsurvey_ajax.createCdpCustomer({ ...entity, client_id: seller_selected_client_id })
        .then(response => {
          console.log(view_key, 'response', response);
          // STEP 3 fetched
          setFetchingSubmit(false);
          setModalPortableContent(false);
          fetchListUniversal(view_key);
        })
        .catch(err => {
          // STEP 3b FAIL
          console.log('CATCH error after axios', err);
          error_msg_handle(err);
          setFetchingSubmit(false);
        })
    } else if (view_key === TABLE_CONSENTS) {
      // STEP 1 spinner
      setFetchingSubmit(true);
      // STEP 2 fetching
      _zzsurvey_ajax.createConsent({ ...entity, client_id: seller_selected_client_id })
        .then(response => {
          console.log(view_key, 'response', response);
          // STEP 3 fetched
          setFetchingSubmit(false);
          setModalPortableContent(false);
          fetchListUniversal(view_key);
        })
        .catch(err => {
          // STEP 3b FAIL
          console.log('CATCH error after axios', err);
          error_msg_handle(err);
          setFetchingSubmit(false);
        })
    }
  };
  //
  const fetchUpdateUniversal = (view_key, entity) => {
    console.log('fetchUpdateUniversal', view_key, entity);
    let id = null;
    if (entity?.id) {
      id = entity.id;
    }
    if (view_key === TABLE_CLIENTS) {
      if (entity?.client_id) {
        id = entity.client_id;
      }
      _zzsurvey_ajax.updateClient(id, entity)
        .then(response => {
          console.log('updateClient response', response);
          // TODO nema pokazatelja da je uspašan update
          setFetchingSubmit(false);
          setModalPortableContent(false);
          fetchListUniversal(view_key);
        })
        .catch(err => {
          // STEP 3b FAIL
          console.log('CATCH error after axios', err);
          error_msg_handle(err);
          setFetchingSubmit(false);
        })
    } else if (view_key === TABLE_CUSTOMERS) {
      if (entity?.customer_id) {
        id = entity.customer_id;
      }
      _zzsurvey_ajax.updateCustomer(id, entity)
        .then(response => {
          console.log('updateCustomer response', response);
          // TODO nema pokazatelja da je uspašan update
          setFetchingSubmit(false);
          setModalPortableContent(false);
          fetchListUniversal(view_key);
        })
        .catch(err => {
          // STEP 3b FAIL
          console.log('CATCH error after axios', err);
          error_msg_handle(err);
          setFetchingSubmit(false);
        })
    } else if (view_key === TABLE_CDP_CUSTOMERS) {
      if (entity?.customer_id) {
        id = entity.customer_id;
      }
      _zzsurvey_ajax.updateCdpCustomer(id, entity)
        .then(response => {
          console.log('updateCdpCustomer response', response);
          // TODO nema pokazatelja da je uspašan update
          setFetchingSubmit(false);
          setModalPortableContent(false);
          fetchListUniversal(view_key);
        })
        .catch(err => {
          // STEP 3b FAIL
          console.log('CATCH error after axios', err);
          error_msg_handle(err);
          setFetchingSubmit(false);
        })
    } else if (view_key === TABLE_TEMPLATES) {

    } else if (view_key === TABLE_INSTANCES) {

    }
  };
  //
  const fetchDeleteUniversal = (view_key, id) => {
    if (view_key === TABLE_CLIENTS) {

    } else if (view_key === TABLE_CUSTOMERS) {

    } else if (view_key === TABLE_TEMPLATES) {

    } else if (view_key === TABLE_INSTANCES) {

    }
  };

  //
  const crudAddUniversal = () => {

  };
  //
  const crudEditUniversal = () => {

  };
  //
  const crudDeleteUniversal = () => {

  };


  // i="fa fa-unlock"
  // i="fa-sign-in"

  // --------- ROUTING AND RENDERING
  let admin_panel_header_title = 'ADMIN PANEL';
  if (route === 'HOME') {
    return (<div className="zzsurvey-app">
      <ZZTempSurveyPublicPageLanding detected_env={detected_env} />
    </div>
    );
  } else if (route === 'QUIZ_FILL') {
    return (
      <div className="zzsurvey-app">
        <ZZTempSurveyPublicPageFillSurvey quiz_key={appState.quiz_key} detected_env={detected_env} />
      </div>
    );
  } else if (route === 'DASHBOARD') {
    // do nothing - DEVPANEL will be rendered
  } else if (route === 'DEVPANEL') {
    admin_panel_header_title = 'DEV PANEL';
    // do nothing - DEVPANEL will be rendered
    // } else if (route === 'NOT_FOUND') {
  } else if (route === 'SIGN_CONSENT') {
    // TODO
    // http://localhost:3000/admin/sign?cdp_sifra=undefined&cdp_customer_id=undefined&cdp_customer_id=undefined
    return (
      <>
        <ZZTempSignConsent routeSimple={appState.routeSimple} error_msg_handle={error_msg_handle} />
      </>
    );
  } else {
    return (
      <div className="zzsurvey-app">
        {
          detected_env === 'DEV' && (
            <div className="zzsurvey-app__env">DEV ENVIRONMENT</div>
          )
        }
        {
          detected_env === 'STG' && (
            <div className="zzsurvey-app__env">STG ENVIRONMENT FOR TESTING</div>
          )
        }
        <div className="zzsurvey__layout-page-wrapper zzsurvey__layout-page-wrapper--public">
          <div className="flex-1"></div>
          <div className="zzsurvey__landing-content">
            <h1>404</h1>
            <p>Oops... page not found.</p>
          </div>
          <div className="flex-2"></div>
        </div>
      </div>
    );
  }


  // ----- rendering DEVPANEL or DASHBOARD or LOGIN

  if (appState.ulogovan === true) {
    // do nothing - DEVPANEL will be rendered
  } else { // login screen
    return (
      <div className="zzsurvey-app">
        <div className="zzsurvey__layout-page-wrapper zzsurvey__layout-page-wrapper--public zzsurvey__layout-page-wrapper--public--auth">
          {
            detected_env === 'DEV' && (
              <div className="zzsurvey-app__env">DEV ENVIRONMENT</div>
            )
          }
          {
            detected_env === 'STG' && (
              <div className="zzsurvey-app__env">STG ENVIRONMENT FOR TESTING</div>
            )
          }
          <div className="flex-1"></div>
          <div className="zzsurvey__landing-content">
            <div className="zzsurvey__card zzsurvey__card--auth">
              <h1>ratemyservice.rs portal</h1>
              <p>{route === 'DEVPANEL' ? 'DEV PANEL ' : ''}Login</p>
              <div>
                <Btn
                  outline
                  circle
                  title='Log in'
                  i="fa fa-sign-in"
                  handleClick={() => {
                    setModalPortableContent({
                      options: {},
                      jsx: (
                        <ZZTempDialogUniversal
                          mode={'ADD'}
                          jsxHeader={<h2 className="heading-on-top">Login</h2>}
                          initialState={{}}
                          formDefinition={_zzsurvey_formDefiinitionLogin}
                          fetchingSubmit={false}
                          cbSubmit={(data) => {
                            _zzsurvey_ajax.login(data)
                              .then((response) => {
                                console.log('login response', response);
                                if (response?.data?.token) {
                                  let client_id = null;
                                  if (response.data?.user?.client) {
                                    client_id = response.data.user.client.client_id;
                                  }
                                  let clients_of_seller = [];
                                  if (response.data?.user?.role === "seller") {
                                    if (Array.isArray(response.data?.clients)) {
                                      clients_of_seller = response.data.clients;
                                    }
                                  }
                                  setAppState(state => {
                                    return {
                                      ...state,
                                      ulogovan: true,
                                      token: response.data.token,
                                      my_user_data: response.data.user,
                                      client_id: client_id,
                                      google_reviews_api_key: null,
                                      google_reviews_place_id: null,
                                      google_reviews_form_link: null,
                                      freshness: state.freshness + 1,
                                      tables_data: {
                                        ...state.tables_data,
                                        [TABLE_CLIENTS_OF_SELLER]: {
                                          ...state.tables_data[TABLE_CLIENTS_OF_SELLER],
                                          data: clients_of_seller,
                                        }
                                      },
                                    };
                                  });
                                  //
                                  // --- AUTH procedure after form login
                                  const _token_val = response.data.token;
                                  _zzsurvey_authUtils.setToken(_token_val);
                                  window.localStorage.setItem(config_TOKEN_LOCAL_KEY, _token_val); // write to local storage
                                  //
                                  //
                                  setModalPortableContent(false);
                                } else {
                                  dispatchShowToast('ERROR No token!', 'RED');
                                }
                                setFetchingSubmit(false);
                              })
                              .catch(err => {

                                console.log('CATCH error after axios', err);
                                error_msg_handle(err);
                              })
                          }}
                          cbCancel={() => { setModalPortableContent(false); }}
                        />),
                    });
                  }}
                />
                {/*
                  route === 'DEVPANEL' && (
                    <Btn
                      outline
                      circle
                      title='Register superadmin'
                      i="fa fa-user-plus"
                      handleClick={() => {
                        setModalPortableContent({
                          options: {},
                          jsx: (<ZZTempDialogUniversal
                            mode={'ADD'}
                            jsxHeader={<h2 className="heading-on-top">Register superadmin</h2>}
                            initialState={{}}
                            formDefinition={_zzsurvey_formDefiinitionRegisterSuperadmin}
                            fetchingSubmit={false}
                            cbSubmit={(data) => {
                              _zzsurvey_ajax.register(data)
                                .then((response) => {
                                  // TODO
                                  setModalPortableContent(false);
                                })
                                .catch(err => {
                                  console.log('CATCH error after axios', err);
                                  error_msg_handle(err);
                                })
                            }}
                            cbCancel={() => { setModalPortableContent(false); }}
                          />),
                        });
                      }}
                    />
                  )
                */}
              </div>
            </div>
          </div>
          <div className="flex-2"></div>
        </div>
        <ModalPortableContainer
          opened={modalPortableContent !== false}
          cbClose={() => { setModalPortableContent(false) }}
          ComponentModal={ModalBottomSheetKoglovoPresentational}
          options={modalPortableContent?.options}
        >
          {
            modalPortableContent && modalPortableContent.jsx && (modalPortableContent.jsx)
          }
        </ModalPortableContainer>
      </div>
    );

  }

  // -----

  // context value that will be received by context consumer or useContext
  const contextValue = {
    survey_template_arr: _extract_single_table_state(appState, TABLE_TEMPLATES).data,
    freshness: appState.freshness,
  };
  global_data_ref.survey_template_arr = _extract_single_table_state(appState, TABLE_TEMPLATES).data;

  const _cb_survey_customer_arr = () => {
    const survey_template_arr = _extract_single_table_state(appState, TABLE_CUSTOMERS).data;
    return survey_template_arr;
  };
  const _cb_survey_template_arr = () => {
    const survey_template_arr = _extract_single_table_state(appState, TABLE_TEMPLATES).data;
    return survey_template_arr;
  };
  const _cb_consents_arr = () => {
    const consents_arr = _extract_single_table_state(appState, TABLE_CONSENTS).data;
    return consents_arr;
  };

  // ----- rendering DEVPANEL or DASHBOARD
  return (
    <ZZTempSurveyContext.Provider value={contextValue}>
      <div className="zzsurvey-app">
        <div className="zzsurvey__layout">
          <div className={"zzsurvey__layout-drawer" + (sidebarOpened ? " zzsurvey__layout-drawer--opened" : "")}>
            <div className="zzsurvey-app__menu-icon" onClick={() => { setSidebarOpened(false); }}><i className="fa fa-times" aria-hidden="true"></i></div>
            <div className="zzsurvey__layout__fix-header-push"></div>
            <div className="zzsurvey__layout-drawer__pad">
              <div className="sidebar-menu">
                <h3 className="">Seller</h3>
                <div className="options-group">
                  <SidebarOption
                    title={'Home'}
                    active={seller_route === 'HOME'}
                    handleClick={() => { setSellerRoute('HOME') }}
                    i="fa fa-home"
                  />
                  <SidebarOption
                    title={'Customers'}
                    active={seller_route === 'CUSTOMERS'}
                    handleClick={() => { setSellerRoute('CUSTOMERS') }}
                    i="fa fa-users"
                  />
                  <SidebarOption
                    title={'Templates'}
                    active={seller_route === 'TEMPLATES'}
                    handleClick={() => { setSellerRoute('TEMPLATES') }}
                    i="fa fa-square-o"
                  />
                  <SidebarOption
                    title={'Answers'}
                    active={seller_route === 'INSTANCES'}
                    handleClick={() => { setSellerRoute('INSTANCES') }}
                    i="fa fa-check-square-o"
                  />
                  <SidebarOption
                    title={'Demo quiz'}
                    active={seller_route === 'DEMO'}
                    handleClick={() => { setSellerRoute('DEMO') }}
                    i="fa fa-play-circle"
                  />
                  <SidebarOption
                    title={'Google reviews'}
                    active={seller_route === 'GOOGLE_REVIEWS'}
                    handleClick={() => { setSellerRoute('GOOGLE_REVIEWS') }}
                    i="fa fa-google"
                  />
                  <SidebarOption
                    title={'Alerts'}
                    active={seller_route === 'ALERTS'}
                    handleClick={() => { setSellerRoute('ALERTS') }}
                    i="fa fa-bell-o"
                  />
                </div>
                <h3>CDP/GDPR</h3>
                <div className="options-group">
                  <SidebarOption
                    title={'CDP customers'}
                    active={seller_route === 'CDP_CUSTOMERS'}
                    handleClick={() => { setSellerRoute('CDP_CUSTOMERS') }}
                    i="fa fa-certificate"
                  />
                  <SidebarOption
                    title={'Consents'}
                    active={seller_route === 'CONSENTS'}
                    handleClick={() => { setSellerRoute('CONSENTS') }}
                    i="fa fa-certificate"
                  />
                  <SidebarOption
                    title={'Signatures'}
                    active={seller_route === 'SIGNATURES'}
                    handleClick={() => { setSellerRoute('SIGNATURES') }}
                    i="fa fa-certificate"
                  />
                </div>
                <h3>Log out</h3>
                <div className="options-group">
                  <SidebarOption
                    title={'Logout'}
                    active={false}
                    handleClick={() => {
                      // dispatchShowModal((<>NESTO</>));
                      // dispatchShowToast('Nije uspela dopuna stavki putem api-ja :(', tclocal.RED);
                      // dispatchShowToastMobile('nesto');
                      _zzsurvey_ajax.logout()
                        .then((response) => {
                          console.log('logout response', response);
                          setAppState(state => {
                            return {
                              // ...state,
                              ...initialAppState,
                              ulogovan: false,
                              my_user_data: null,
                              token: null,
                              freshness: state.freshness + 1,
                            }
                          });
                          //
                          // --- AUTH procedure after logout
                          _zzsurvey_authUtils.setToken('NONE');
                          window.localStorage.removeItem(config_TOKEN_LOCAL_KEY); // delete from localstorage
                          //
                          setFetchingSubmit(false);
                          if (typeof response?.data?.message === 'string') {
                            dispatchShowToast(response.data.message, 'BLUE');
                          }
                        })
                    }}
                    i="fa fa-sign-out"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="zzsurvey__layout-main">
            <div className="zzsurvey__layout-page-wrapper">
              {
                detected_env === 'DEV' && (
                  <div className="zzsurvey-app__env">DEV ENVIRONMENT</div>
                )
              }
              {
                (detected_env === 'STG') && (
                  <div className="zzsurvey-app__env">STG ENVIRONMENT FOR TESTING</div>
                )
              }
              <div className="zzsurvey__layout-page-header">
                <div className="zzsurvey-app__menu-icon" onClick={() => { setSidebarOpened(true); }}><i className="fa fa-bars" aria-hidden="true"></i></div>
                <div className="zzsurvey__layout-page-header__bar">
                  <div className="zzsurvey__logo-bar">
                    <h1 className="zzsurvey__logo-text">ratemyservice.rs portal</h1>
                    <span>{admin_panel_header_title}</span>
                  </div>
                  <div className="zzsurvey__layout-page-header__bar__corner-auth">
                    <i className="fa fa-sign-out"></i><span
                      className="clickable"
                      onClick={() => {
                        // dispatchShowModal((<>NESTO</>));
                        // dispatchShowToast('Nije uspela dopuna stavki putem api-ja :(', tclocal.RED);
                        // dispatchShowToastMobile('nesto');
                        _zzsurvey_ajax.logout()
                          .then((response) => {
                            console.log('logout response', response);
                            setAppState(state => {
                              return {
                                // ...state,
                                ...initialAppState,
                                ulogovan: false,
                                my_user_data: null,
                                token: null,
                                freshness: state.freshness + 1,
                              }
                            });
                            //
                            // --- AUTH procedure after logout
                            _zzsurvey_authUtils.setToken('NONE');
                            window.localStorage.removeItem(config_TOKEN_LOCAL_KEY); // delete from localstorage
                            //
                            setFetchingSubmit(false);
                            if (typeof response?.data?.message === 'string') {
                              dispatchShowToast(response.data.message, 'BLUE');
                            }
                          })
                      }}
                    >Logout</span>
                  </div>
                </div>
              </div>
              <div className="zzsurvey__layout__fix-header-push"></div>
              <div className="zzsurvey__layout-page-body-section-dev">
                <CardCollapsible jsxHeader={<h2>DEV PANEL - Debug & Testing</h2>} >
                  <div>
                    <h3>info:</h3>
                    <JSDisplayValue val={info} />
                    <br />
                    <CardCollapsible small jsxHeader={<h3>appState</h3>} >
                      <JSDisplayValue val={appState} />
                    </CardCollapsible>
                  </div>
                  <br />
                  <div>
                    <h3>podešavanja:</h3>
                    <div className="vector row gaps">
                      <div className="xi">
                        <div>For example: 'http://localhost:9000' or 'http://ratemyservice.rs'</div>
                        <form>
                          <FormFieldGenerator
                            fieldDefinition={{
                              "type": "input_text",
                              "params": {
                                "label": "URL prefix (for API calls)",
                                "name": "url",
                                "placeholder": "http://ratemyservice.rs",
                                "w": 320
                              }
                            }}
                            value={_zzsurvey_urlLib.websitePrefix()}
                            handleChange={(e) => {
                              _zzsurvey_urlLib.websitePrefix_set(e.target.value);
                              _fresh();
                            }}
                          />
                        </form>
                      </div>
                      <div className="xi"></div>
                    </div>
                  </div>
                  <br />

                  <CardCollapsible jsxHeader={<h2>PUBLIC fill survey - route: /surver/quiz_key</h2>} >
                    <ZZTempSurveyPublicPageFillSurvey quiz_key={appState.quiz_key} />
                  </CardCollapsible>

                  <CardCollapsible jsxHeader={<h2>DEV Auth login/logout/register</h2>} >
                    <div className="uu-w-max-content">
                      <Btn
                        outline
                        circle
                        title='Log in'
                        i="fa fa-sign-in"
                        handleClick={() => {
                          setModalPortableContent({
                            options: {},
                            jsx: (<ZZTempDialogUniversal
                              mode={'ADD'}
                              jsxHeader={<h2 className="heading-on-top">Login</h2>}
                              initialState={{}}
                              formDefinition={_zzsurvey_formDefiinitionLogin}
                              fetchingSubmit={false}
                              cbSubmit={(data) => {
                                _zzsurvey_ajax.login(data)
                                  .then((response) => {
                                    console.log('login response', response);
                                    if (response?.data?.token) {
                                      let client_id = null;
                                      if (response.data?.user?.client) {
                                        client_id = response.data.user.client.client_id;
                                      }
                                      let clients_of_seller = [];
                                      if (response.data?.user?.role === "seller") {
                                        if (Array.isArray(response.data?.clients)) {
                                          clients_of_seller = response.data.clients;
                                        }
                                      }
                                      setAppState(state => {
                                        return {
                                          ...state,
                                          ulogovan: true,
                                          token: response.data.token,
                                          my_user_data: response.data.user,
                                          client_id: client_id,
                                          google_reviews_api_key: null,
                                          google_reviews_place_id: null,
                                          google_reviews_form_link: null,
                                          freshness: state.freshness + 1,
                                          tables_data: {
                                            ...state.tables_data,
                                            [TABLE_CLIENTS_OF_SELLER]: {
                                              ...state.tables_data[TABLE_CLIENTS_OF_SELLER],
                                              data: clients_of_seller,
                                            }
                                          },
                                        }
                                      });
                                      setModalPortableContent(false);
                                    } else {
                                      dispatchShowToast('ERROR No token!', 'RED');
                                    }
                                    setFetchingSubmit(false);
                                  })
                                  .catch(err => {
                                    console.log('CATCH error after axios', err);
                                    error_msg_handle(err);
                                  })
                              }}
                              cbCancel={() => { setModalPortableContent(false); }}
                            />),
                          });
                        }}
                      />
                      <Btn
                        outline
                        circle
                        title='Log out'
                        i="fa fa-sign-out"
                        handleClick={() => {
                          // dispatchShowModal((<>NESTO</>));
                          // dispatchShowToast('Nije uspela dopuna stavki putem api-ja :(', tclocal.RED);
                          // dispatchShowToastMobile('nesto');
                          _zzsurvey_ajax.logout()
                            .then((response) => {
                              console.log('logout response', response);
                              setAppState(state => {
                                return {
                                  ...state,
                                  ulogovan: false,
                                  my_user_data: null,
                                  token: null,
                                  freshness: state.freshness + 1,
                                }
                              });
                              //
                              // --- AUTH procedure after logout
                              _zzsurvey_authUtils.setToken('NONE');
                              window.localStorage.removeItem(config_TOKEN_LOCAL_KEY); // delete from localstorage
                              //
                              setFetchingSubmit(false);
                              if (typeof response?.data?.message === 'string') {
                                dispatchShowToast(response.data.message, 'BLUE');
                              }
                            })
                            .catch(err => {
                              console.log('CATCH error after axios', err);
                              error_msg_handle(err);
                            })

                        }}
                      />
                      <Btn
                        outline
                        circle
                        title='Register superadmin'
                        i="fa fa-user-plus"
                        handleClick={() => {
                          setModalPortableContent({
                            options: {},
                            jsx: (<ZZTempDialogUniversal
                              mode={'ADD'}
                              jsxHeader={<h2 className="heading-on-top">Register superadmin</h2>}
                              initialState={{}}
                              formDefinition={_zzsurvey_formDefiinitionRegisterSuperadmin}
                              fetchingSubmit={false}
                              cbSubmit={(data) => {
                                _zzsurvey_ajax.register(data)
                                  .then((response) => {
                                    // TODO
                                    setModalPortableContent(false);
                                  })
                                  .catch(err => {
                                    console.log('CATCH error after axios', err);
                                    error_msg_handle(err);
                                  })
                              }}
                              cbCancel={() => { setModalPortableContent(false); }}
                            />),
                          });
                        }}
                      />
                      {/*
                  <Btn
                    disabled={true}
                    outline
                    circle
                    title='Register seller'
                    i="fa fa-user-plus"
                    handleClick={() => {
                      setModalPortableContent({
                        options: {},
                        jsx: (<ZZTempDialogUniversal
                          mode={'ADD'}
                          jsxHeader={<h2 className="heading-on-top">Register seller</h2>}
                          initialState={{}}
                          formDefinition={_zzsurvey_formDefiinitionRegisterSuperadmin}
                          fetchingSubmit={false}
                          cbSubmit={(data) => {
                            _zzsurvey_ajax.createSeller(appState.client_id, data)
                              .then(() => {

                              })
                            setModalPortableContent(false);
                          }}
                          cbCancel={() => { setModalPortableContent(false); }}
                        />),
                      });
                    }}
                  />
                  */}
                    </div>
                  </CardCollapsible>
                </CardCollapsible>
              </div>


              <div className="zzsurvey__layout-page-body">
                <div className="zzsurvey-app__version">Version: {app_build_version_id_zzsurveyapp}</div>
                {
                  route === 'DEVPANEL' ? (
                    <h1>DEV PANEL</h1>
                  ) : (null)
                }
                {
                  appState.ulogovan === true && appState?.my_user_data?.email && (
                    <>
                      <p>
                        <span>User: <b>{appState.my_user_data.email}</b></span> <span>Role: <b>{appState.my_user_data.role}</b></span>
                      </p>
                    </>
                  )
                }
                {
                  appState.ulogovan === true && appState?.my_user_data?.role === "seller" && (
                    <>
                      <div className="zzsurvey__dashboard-cards">
                        <div className="xi">
                          <div className="zzsurvey__card zzsurvey__card--select-company">
                            <div>
                              <h4 className="uu-margin-0">Select company</h4>
                              <div>
                                <FormFieldGenerator
                                  fieldDefinition={{
                                    "type": "input_radio_group",
                                    "params": {
                                      "valuetype": "number",
                                      "integer": true,
                                      "label": "Select client",
                                      "name": "seller_selected_client_id",
                                      "options": _options_clients_of_seller,
                                      "outline": false,
                                      "extraclass": "novo-radios-column",
                                    }
                                  }}
                                  value={seller_selected_client_id}
                                  handleChange={(e) => {
                                    const client_id = Number.parseInt(e.target.value);
                                    setAppState(state => {
                                      let google_reviews_api_key = null;
                                      let google_reviews_place_id = null;
                                      let google_reviews_form_link = null;
                                      if (typeof _clients_of_seller_obj?.[client_id]?.api_key === 'string') {
                                        google_reviews_api_key = _clients_of_seller_obj?.[client_id]?.api_key
                                      }
                                      if (typeof _clients_of_seller_obj?.[client_id]?.place_id === 'string') {
                                        google_reviews_place_id = _clients_of_seller_obj?.[client_id]?.place_id
                                      }
                                      //
                                      return {
                                        ...state,
                                        seller_selected_client_id: client_id,
                                        seller_selected_multiple_ccustomer_ids: [], // RESET
                                        seller_route: 'HOME',
                                        google_reviews_api_key,
                                        google_reviews_place_id,
                                        google_reviews_form_link,
                                      };
                                    });
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )
                }

                {/*
            <div className="zzsurvey__card zzsurvey__card--auth">
              <Btn
                outline
                circle
                title='Log out'
                i="fa fa-sign-out"
                handleClick={() => {
                  // dispatchShowModal((<>NESTO</>));
                  // dispatchShowToast('Nije uspela dopuna stavki putem api-ja :(', tclocal.RED);
                  // dispatchShowToastMobile('nesto');
                  _zzsurvey_ajax.logout()
                    .then((response) => {
                      console.log('logout response', response);
                      setAppState(state => {
                        return {
                          ...state,
                          ulogovan: false,
                          my_user_data: null,
                          token: null,
                          freshness: state.freshness + 1,
                        }
                      });
                      setFetchingSubmit(false);
                      if (typeof response?.data?.message === 'string') {
                        dispatchShowToast(response.data.message, 'BLUE');
                      }
                    })

                }}
              />
            </div>
            <br />
            */}

                <RenderIfTrue condition={is_superadmin}>
                  <CardCollapsible jsxHeader={<h2>SUPERADMIN PANEL</h2>} >
                    <CardCollapsible jsxHeader={<h2>SUPERADMIN Admin panel clients</h2>} >
                      <ViewGeneratorSimple
                        viewDefinition={{
                          view_key: TABLE_CLIENTS,
                          table_additional_column_keys: ["client_id", "name", "email", "phone", "is_active"],
                          cbEntityKeyExtractor: (entity, index) => {
                            console.log('cbEntityKeyExtractor', entity);
                            return entity.client_id;
                          },
                          options: {
                            entity_col_disabled: false,
                          },
                          cbRefresh: () => { fetchListUniversal(TABLE_CLIENTS); },
                          cbEntityActionsJsx: (entity, payload) => {
                            // return JSX action buttons
                            return (
                              <>
                                <div className="uu-text-wrap">
                                  <Btn
                                    disabled={false}
                                    title={'Edit'}
                                    btnColor={'btn--color-mui-indigo'}
                                    btnSmallWithTitle
                                    inline
                                    i='fa fa-pencil'
                                    tooltip='Edit entity'
                                    handleClick={() => {
                                      setModalPortableContent({
                                        options: {},
                                        jsx: (
                                          <ZZTempDialogUniversal
                                            mode={'EDIT'}
                                            jsxHeader={<h2 className="heading-on-top">Edit client</h2>}
                                            initialState={{ ...entity }}
                                            formDefinition={_zzsurvey_formDefiinitionClient}
                                            fetchingSubmit={appState.fetchingSubmit}
                                            cbSubmit={(entbox) => {
                                              const _entbox = entbox;
                                              if (typeof entbox.email === 'string') {
                                                _entbox.email = entbox.email.trim().toLowerCase();
                                              }
                                              fetchUpdateUniversal(TABLE_CLIENTS, _entbox)
                                            }}
                                            cbCancel={() => { setModalPortableContent(false); }}
                                          />),
                                      });
                                    }}
                                  />
                                  <Btn
                                    disabled={entity.is_active === true}
                                    title={'Activate'}
                                    btnColor={'btn--color-mui-indigo'}
                                    btnSmallWithTitle
                                    inline
                                    i='fa fa-toggle-on'
                                    tooltip='Activate client'
                                    handleClick={() => {
                                      // TODO
                                      _zzsurvey_ajax.activateClient(entity.client_id, entity)
                                        .then(response => {
                                          console.log('activateClient response', response);
                                          fetchListUniversal(TABLE_CLIENTS);
                                        })
                                        .catch(err => {
                                          console.log('CATCH error after axios', err);
                                          error_msg_handle(err);
                                        })
                                    }}
                                  />
                                  <Btn
                                    disabled={entity.is_active === false}
                                    title={'Deactivate SOFT'}
                                    btnColor={'btn--red'}
                                    btnSmallWithTitle
                                    inline
                                    i='fa fa-toggle-off'
                                    tooltip='Deactivate client'
                                    handleClick={() => {
                                      if (window.confirm("Da li ste sigurni da želite da deaktivirate klijenta?")) {
                                        // TODO
                                        // crudDeleteUniversal();
                                        _zzsurvey_ajax.deactivateClient(entity.client_id, false)
                                          .then(response => {
                                            console.log('deactivateClient SOFT response', response);
                                            fetchListUniversal(TABLE_CLIENTS);
                                          })
                                          .catch(err => {
                                            console.log('CATCH error after axios', err);
                                            error_msg_handle(err);
                                          })
                                      }
                                    }}
                                  />
                                  <Btn
                                    disabled={entity.is_active === false}
                                    title={'Deactivate HARD'}
                                    btnColor={'btn--red'}
                                    btnSmallWithTitle
                                    inline
                                    i='fa fa-trash'
                                    tooltip='Deactivate client'
                                    handleClick={() => {
                                      if (window.confirm("Da li ste sigurni da želite da obrišete klijenta?")) {
                                        // TODO
                                        // crudDeleteUniversal();
                                        _zzsurvey_ajax.deactivateClient(entity.client_id, true)
                                          .then(response => {
                                            console.log('deactivateClient HARD response', response);
                                            fetchListUniversal(TABLE_CLIENTS);
                                          })
                                          .catch(err => {
                                            console.log('CATCH error after axios', err);
                                            error_msg_handle(err);
                                          })
                                      }
                                    }}
                                  />
                                </div>
                              </>
                            );
                          },

                        }}
                        viewArr={_extract_single_table_state(appState, TABLE_CLIENTS).data}
                        fetching={_extract_single_table_state(appState, TABLE_CLIENTS).fetching}
                        jsxSpinner={<SpinnerClassic />}
                      />
                      <div className="zzsurvey__view-footer">
                        <Btn
                          disabled={false}
                          title={'Add'}
                          btnColor={'btn--color-mui-indigo'}
                          btnSmallWithTitle
                          inline
                          i='fa fa-plus'
                          tooltip='Add entity'
                          handleClick={() => {
                            setModalPortableContent({
                              options: {},
                              jsx: (<ZZTempDialogUniversal
                                mode={'ADD'}
                                jsxHeader={<h2 className="heading-on-top">Add client</h2>}
                                initialState={{}}
                                formDefinition={_zzsurvey_formDefiinitionClient}
                                fetchingSubmit={appState.fetchingSubmit}
                                cbSubmit={(entbox) => {
                                  const _entbox = entbox;
                                  if (typeof entbox.email === 'string') {
                                    _entbox.email = entbox.email.trim().toLowerCase();
                                  }
                                  fetchCreateUniversal(TABLE_CLIENTS, _entbox);
                                }}
                                cbCancel={() => { setModalPortableContent(false); }}
                              />),
                            });
                          }}
                        />
                        <Btn
                          disabled={false}
                          title={'Refresh'}
                          btnSmallWithTitle
                          inline
                          i='fa fa-refresh'
                          tooltip='Refresh'
                          handleClick={() => { fetchListUniversal(TABLE_CLIENTS); }}
                        />
                      </div>
                    </CardCollapsible>

                    <CardCollapsible jsxHeader={<h2>SUPERADMIN Admin panel sellers</h2>} >
                      <FrfrUtilsCbWhenMounted componentDidMount={() => { fetchListUniversal(TABLE_CLIENTS); }} />
                      {
                        _extract_single_table_state(appState, TABLE_CLIENTS).fetching === true ? (
                          <SpinnerClassic />
                        ) : (
                          <>
                            <div className="uu-w-max-content">
                              <FormFieldGenerator
                                fieldDefinition={{
                                  "type": "select",
                                  "params": {
                                    "label": "superadmin_selected_client_id",
                                    "name": "superadmin_selected_client_id",
                                    "default_option_title": "--select client--",
                                    "options": _extract_single_table_state(appState, TABLE_CLIENTS).data.map((item) => {
                                      console.log('***opt', item);
                                      return { "title": (' ' + item.name + ' ' + item.email), "value": item.client_id };
                                    }),
                                  }
                                }}
                                value={appState.superadmin_selected_client_id}
                                handleChange={(e) => {
                                  setAppState(appState => {
                                    return {
                                      ...appState,
                                      superadmin_selected_client_id: e.target.value
                                    };
                                  })
                                }}
                              />
                            </div>
                            <br />
                            {
                              true || appState.superadmin_selected_client_id ? (
                                <>
                                  {/*<CardCollapsible jsxHeader={<h4>Sellers of client client_id: <b>{appState.superadmin_selected_client_id}</b></h4>}></CardCollapsible>*/}
                                  <CardCollapsible jsxHeader={<h4>Sellers all</h4>}>
                                    <ViewGeneratorSimple
                                      viewDefinition={{
                                        view_key: TABLE_SELLERS,
                                        table_additional_column_keys: [
                                          // SUPERADMIN
                                          "user_id",
                                          "email",
                                          "name",
                                          // "surname",
                                          "role",
                                          "client_id"
                                        ],
                                        cbEntityKeyExtractor: (entity, index) => {
                                          return entity.user_id;
                                        },
                                        options: {
                                          entity_col_disabled: false,
                                        },
                                        cbRefresh: () => { fetchListUniversal(TABLE_SELLERS, { client_id: appState.superadmin_selected_client_id }); },
                                        cbEntityActionsJsx: (entity, payload) => {
                                          // return JSX action buttons
                                          return (
                                            <>
                                              <Btn
                                                disabled={false}
                                                title={''}
                                                btnColor={'btn--color-mui-indigo'}
                                                btnSmall
                                                inline
                                                i='fa fa-link'
                                                tooltip='Bind seller to clients'
                                                handleClick={() => {
                                                  setModalPortableContent({
                                                    options: {},
                                                    jsx: (<>
                                                      <ZZTempDialogUniversal
                                                        extraProps={{
                                                          mode_bind_client: true,
                                                          clients_all_arr: _extract_single_table_state(appState, TABLE_CLIENTS).data,
                                                        }}
                                                        mode={'EDIT'}
                                                        jsxHeader={<h2 className="heading-on-top">Bind seller to clients</h2>}
                                                        initialState={(() => {
                                                          // make initial bind seller state
                                                          let client_ids = [];
                                                          entity.clients.forEach(item => {
                                                            if (item.client_id > 0) {
                                                              client_ids.push(item.client_id);
                                                            }
                                                          });
                                                          return {
                                                            ...entity,
                                                            client_ids,
                                                          };
                                                        })()}
                                                        formDefinition={() => {
                                                          return [];
                                                          // return _zzsurvey_formDefiinitionRegisterSuperadmin;
                                                        }}
                                                        fetchingSubmit={appState.fetchingSubmit}
                                                        cbSubmit={(formState) => {
                                                          // SUBMIT bind seller to client
                                                          const seller_id = formState.user_id;
                                                          const data = {
                                                            client_ids: formState.client_ids
                                                          };
                                                          _zzsurvey_ajax.bindSellerToClients(seller_id, data)
                                                            .then(response => {
                                                              console.log('bindSellerToClients response', response);
                                                              // TODO
                                                              // STEP 3 fetched
                                                              setFetchingSubmit(false);
                                                              setModalPortableContent(false);
                                                              fetchListUniversal(TABLE_SELLERS, { client_id: appState.superadmin_selected_client_id });
                                                            })
                                                            .catch(err => {
                                                              // STEP 3b FAIL
                                                              console.log('CATCH error after axios', err);
                                                              error_msg_handle(err);
                                                              setFetchingSubmit(false);
                                                            })

                                                        }}
                                                        cbCancel={() => { setModalPortableContent(false); }}
                                                      />
                                                    </>),
                                                  });
                                                }}
                                              />
                                              {/*
                                              <Btn
                                                disabled={true}
                                                title={''}
                                                btnColor={'btn--color-mui-indigo'}
                                                btnSmall
                                                inline
                                                i='fa fa-link'
                                                tooltip='Edit entity'
                                                handleClick={() => {
                                                  setModalPortableContent({
                                                    options: {},
                                                    jsx: (<>
                                                      <ZZTempDialogUniversal
                                                        mode={'EDIT'}
                                                        jsxHeader={<h2 className="heading-on-top">Edit seller</h2>}
                                                        initialState={entity}
                                                        formDefinition={() => {
                                                          return _zzsurvey_formDefiinitionRegisterSuperadmin;
                                                        }}
                                                        fetchingSubmit={appState.fetchingSubmit}
                                                        cbSubmit={(data) => { fetchUpdateUniversal(TABLE_SELLERS, data) }}
                                                        cbCancel={() => { setModalPortableContent(false); }}
                                                      />
                                                    </>),
                                                  });
                                                }}
                                              />
                                              */}
                                            </>
                                          );
                                        },
                                      }}
                                      viewArr={_extract_single_table_state(appState, TABLE_SELLERS).data}
                                      fetching={_extract_single_table_state(appState, TABLE_SELLERS).fetching}
                                      jsxSpinner={<SpinnerClassic />}
                                    />
                                    <h4>Reggister seller of client client_id {appState.superadmin_selected_client_id}</h4>
                                    <div className="zzsurvey__view-footer">
                                      <div className="uu-w-max-content">
                                        <Btn
                                          outline
                                          circle
                                          title='Register seller'
                                          i="fa fa-user-plus"
                                          handleClick={() => {
                                            setModalPortableContent({
                                              options: {},
                                              jsx: (<ZZTempDialogUniversal
                                                mode={'ADD'}
                                                jsxHeader={<h2 className="heading-on-top">Register seller</h2>}
                                                initialState={{}}
                                                formDefinition={_zzsurvey_formDefiinitionRegisterSeller}
                                                fetchingSubmit={false}
                                                cbSubmit={(entbox) => {
                                                  const _entbox = entbox;
                                                  if (typeof entbox.email === 'string') {
                                                    _entbox.email = entbox.email.trim().toLowerCase();
                                                  }
                                                  _zzsurvey_ajax.createSeller(appState.superadmin_selected_client_id, _entbox)
                                                    .then((response) => {
                                                      console.log('response', response);
                                                      fetchListUniversal(TABLE_SELLERS, { client_id: appState.superadmin_selected_client_id });
                                                      setModalPortableContent(false);
                                                    })
                                                    .catch(err => {
                                                      console.log('CATCH error after axios', err);
                                                      error_msg_handle(err);
                                                    })
                                                }}
                                                cbCancel={() => { setModalPortableContent(false); }}
                                              />),
                                            });
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </CardCollapsible>
                                </>
                              ) : (
                                <div className="zzsurvey__editor__error-msg2"><i>You must select client</i></div>
                              )
                            }
                          </>
                        )
                      }
                    </CardCollapsible>

                    {/*
            <CardCollapsible jsxHeader={<h2>SUPERADMIN Admin panel register seller</h2>} >
            </CardCollapsible>
            */}

                    <CardCollapsible jsxHeader={<h2>SELLER Admin panel survey instances ALL</h2>} >
                      <ViewGeneratorSimple
                        viewDefinition={{
                          view_key: TABLE_INSTANCES,
                          table_additional_column_keys: ['survey_instance_id', 'date_filled', 'status', 'service_date', 'date_due', 'is_first_email_sent', 'is_second_email_sent', 'date_to_send_first_email', 'date_to_send_second_email',
                            'customer_id', 'survey_template_id',
                            'service_type'],
                          cbEntityKeyExtractor: (entity, index) => {
                            return entity.survey_instance_id;
                          },
                          options: {
                            entity_col_disabled: false,
                          },
                          cbRefresh: () => { fetchListUniversal(TABLE_INSTANCES); },
                          cbEntityActionsJsx: (entity, payload) => {
                            // return JSX action buttons
                            return (
                              <>
                                <Btn
                                  disabled={false}
                                  title={'Answers'}
                                  btnColor={'btn--color-mui-green-darken-3'}
                                  btnSmallWithTitle
                                  inline
                                  i='fa fa-eye'
                                  tooltip='Display answers'
                                  handleClick={() => {
                                    setModalPortableContent({
                                      options: { large: true },
                                      jsx: (
                                        <>
                                          <h3>Display answers - instance_id: {entity.survey_instance_id}</h3>
                                          <ZZTempSurveyQuizFill
                                            mode={'LIVE_PREVIEW'}
                                            previewIsAnon={entity.is_anonymous}
                                            quiz_key={null}
                                            quizBlueprint={_zzsurvey_utils_backendQuizBlueprint_to_quizBlueprint(entity)}
                                            cbSubmit={(quiz_key, entbox) => { window.alert('This is just a display :)'); }}
                                          />
                                        </>
                                      ),
                                    });
                                  }}
                                />
                                {/*
                          <Btn
                            disabled={false}
                            title={''}
                            btnColor={'btn--color-mui-indigo'}
                            btnSmall
                            inline
                            i='fa fa-pencil'
                            tooltip='Edit entity'
                            handleClick={() => {
                              // setModalPortableContent();
                            }}
                          />
                          */}
                                {/*
                          <Btn
                            disabled={true}
                            title={''}
                            btnColor={'btn--red'}
                            btnSmall
                            inline
                            i='fa fa-trash'
                            tooltip='Delete entity'
                            handleClick={() => {
                              if (window.confirm("Da li ste sigurni da želite da obrišete entitet?")) {
                                // TODO
                                crudDeleteUniversal();
                              }
                            }}
                          />
                          */}
                              </>
                            );
                          },

                        }}
                        viewArr={_extract_single_table_state(appState, TABLE_INSTANCES).data}
                        fetching={_extract_single_table_state(appState, TABLE_INSTANCES).fetching}
                        jsxSpinner={<SpinnerClassic />}
                      />
                      <div className="zzsurvey__view-footer">
                        <Btn
                          disabled={true}
                          title={'Add'}
                          btnColor={'btn--color-mui-indigo'}
                          btnSmallWithTitle
                          inline
                          i='fa fa-plus'
                          tooltip='Add instance'
                          handleClick={() => {
                            setModalPortableContent({
                              options: {},
                              jsx: (<ZZTempDialogUniversal
                                mode={'ADD'}
                                jsxHeader={<h2 className="heading-on-top">Add instance</h2>}
                                initialState={{
                                  service_date: new Date().toISOString().substring(0, 10),
                                }}
                                formDefinition={() => {
                                  return _zzsurvey_formDefiinitionInstance(_cb_survey_customer_arr, _cb_survey_template_arr);
                                }}
                                fetchingSubmit={appState.fetchingSubmit}
                                cbSubmit={(entbox) => {
                                  const _entbox = { ...entbox };
                                  if (typeof entbox.email === 'string') {
                                    _entbox.email = entbox.email.trim().toLowerCase();
                                  }
                                  _entbox.customer_ids = [entbox.customer_id];
                                  _entbox.customer_id = null;
                                  fetchCreateUniversal(TABLE_INSTANCES, _entbox);
                                  //
                                }}
                                cbCancel={() => { setModalPortableContent(false); }}
                                componentDidMount={() => {
                                  fetchListUniversal(TABLE_CUSTOMERS);
                                  fetchListUniversal(TABLE_TEMPLATES);
                                }}
                              />),
                            });
                          }}
                        />
                        <Btn
                          disabled={false}
                          title={'Excel export'}
                          btnColor={'btn--color-mui-green-darken-3'}
                          btnSmallWithTitle
                          inline
                          i='fa fa-file-excel-o'
                          tooltip='Export to excel'
                          handleClick={() => { _zzsurvey_utils_export_excel_table_v0_1(_extract_single_table_state(appState, TABLE_INSTANCES).data); }}
                        />
                        <Btn
                          disabled={false}
                          title={'Excel export SVE'}
                          btnColor={'btn--color-mui-green-darken-3'}
                          btnSmallWithTitle
                          inline
                          i='fa fa-file-excel-o'
                          tooltip='Export to excel'
                          handleClick={() => { _zzsurvey_utils_export_excel_table_v0_1(_extract_single_table_state(appState, TABLE_INSTANCES).data, true); }}
                        />
                        <Btn
                          disabled={false}
                          title={'Refresh'}
                          btnSmallWithTitle
                          inline
                          i='fa fa-refresh'
                          tooltip='Refresh'
                          handleClick={() => { fetchListUniversal(TABLE_INSTANCES); }}
                        />
                        {/*
                      <Btn
                        disabled={false}
                        title={''}
                        btnSmall
                        inline
                        i='fa fa-refresh'
                        tooltip='Refresh'
                        handleClick={() => { fetchListUniversal(TABLE_INSTANCES); }}
                      />
                      */}
                      </div>
                    </CardCollapsible>
                  </CardCollapsible>
                </RenderIfTrue>


                <SellerCardPage pageRouteActive={seller_route === 'DEMO'} extraClass="zzsurvey__custom-widget-card-big" jsxHeader={<h1>DEMO Quiz editor & Quiz preview</h1>} >
                  <ZZTempSurveyQuizEditorContainer
                    mode={'DEMO'}
                    cbSubmit={() => { window.alert('This is just a DEMO :)'); }}
                    cbCancel={() => { setModalPortableContent(false); }}
                  />
                </SellerCardPage>

                {
                  seller_selected_client_id > 0 ? (
                    <SellerCardPage pageRouteActive={true} disableHeader={true} jsxHeader={<h2>Seller Dashboard</h2>} >
                      <SellerCardPage pageRouteActive={seller_route === 'HOME'} jsxHeader={<h1>Seller admin panel</h1>}>
                        <div className="zzsurvey__dashboard-cards">
                          {/*
                      <div className="xi">
                        <div className="zzsurvey__card">
                          <SidebarOption
                            title={'Home'}
                            active={seller_route === 'HOME'}
                            handleClick={() => { setSellerRoute('HOME') }}
                            i="fa fa-home"
                          />
                        </div>
                      </div>
                      */}
                          <div className="xi">
                            <div className="zzsurvey__card">
                              <SidebarOption
                                title={'Customers'}
                                active={seller_route === 'CUSTOMERS'}
                                handleClick={() => { setSellerRoute('CUSTOMERS') }}
                                i="fa fa-users"
                              />
                              <p>Customers of your services and participants in surveys</p>
                            </div>
                          </div>
                          <div className="xi">
                            <div className="zzsurvey__card">
                              <SidebarOption
                                title={'Demo quiz'}
                                active={seller_route === 'DEMO'}
                                handleClick={() => { setSellerRoute('DEMO') }}
                                i="fa fa-play-circle"
                              />
                              <p>See how quiz editor and quiz form work</p>
                            </div>
                          </div>
                          <div className="xi">
                            <div className="zzsurvey__card">
                              <SidebarOption
                                title={'Templates'}
                                active={seller_route === 'TEMPLATES'}
                                handleClick={() => { setSellerRoute('TEMPLATES') }}
                                i="fa fa-square-o"
                              />
                              <p>Survey form/quiz to be filled</p>
                            </div>
                          </div>
                          <div className="xi">
                            <div className="zzsurvey__card">
                              <SidebarOption
                                title={'Answers'}
                                active={seller_route === 'INSTANCES'}
                                handleClick={() => { setSellerRoute('INSTANCES') }}
                                i="fa fa-check-square-o"
                              />
                              <p>Answers filled by customers</p>
                            </div>
                          </div>
                          <div className="xi">
                            <div className="zzsurvey__card">
                              <SidebarOption
                                title={'Google reviews'}
                                active={seller_route === 'GOOGLE_REVIEWS'}
                                handleClick={() => { setSellerRoute('GOOGLE_REVIEWS') }}
                                i="fa fa-google"
                              />
                              <p>Google reviews</p>
                            </div>
                          </div>
                          <div className="xi">
                            <div className="zzsurvey__card">
                              <SidebarOption
                                title={'Alerts'}
                                active={seller_route === 'ALERTS'}
                                handleClick={() => { setSellerRoute('ALERTS') }}
                                i="fa fa-bell-o"
                              />
                              <p>Customers left negative feedback</p>
                            </div>
                          </div>
                          <div className="xi">
                            <div className="zzsurvey__card">
                              <SidebarOption
                                title={'CDP customers'}
                                active={seller_route === 'CDP_CUSTOMERS'}
                                handleClick={() => { setSellerRoute('CDP_CUSTOMERS') }}
                                i="fa fa-certificate"
                              />
                              <p>CDP customers (for GDPR consents signing)</p>
                            </div>
                          </div>
                          <div className="xi">
                            <div className="zzsurvey__card">
                              <SidebarOption
                                title={'Consents'}
                                active={seller_route === 'CONSENTS'}
                                handleClick={() => { setSellerRoute('CONSENTS') }}
                                i="fa fa-certificate"
                              />
                              <p>GDPR consents text</p>
                            </div>
                          </div>
                          <div className="xi">
                            <div className="zzsurvey__card">
                              <SidebarOption
                                title={'Signatures'}
                                active={seller_route === 'SIGNATURES'}
                                handleClick={() => { setSellerRoute('SIGNATURES') }}
                                i="fa fa-certificate"
                              />
                              <p>Signatures - Signed consents. Which cdp_customer signed which consent. </p>
                            </div>
                          </div>
                        </div>
                      </SellerCardPage>

                      <SellerCardPage pageRouteActive={seller_route === 'CUSTOMERS'} jsxHeader={<h1>Customers</h1>} >
                        {/* TODO filter prodaja servis */}
                        <div className="uu-form-vector-row IZMENIME">
                          <div className="uu-w-max-content">
                            <FormFieldGenerator
                              fieldDefinition={{
                                "type": "select",
                                "params": {
                                  // "valuetype": "number",
                                  // "integer": true,
                                  "label": "Prodja/Servis",
                                  "name": "customers_filter",
                                  "options": [
                                    { "title": "Prikaži sve", "value": "" },
                                    { "title": "Prodaja", "value": "PRODAJA" },
                                    { "title": "Servis", "value": "SERVIS" },
                                    { "title": "Prodaja i servis", "value": "PRODAJA_I_SERVIS" },
                                  ],
                                  // "outline": false,
                                  "withoutdefaultoption": true,
                                  "extraclass": "novo-radios-row",
                                }
                              }}
                              value={appState.customers_filter}
                              handleChange={(e) => {
                                const customers_filter = e.target.value;
                                setAppState(state => {
                                  return {
                                    ...state,
                                    customers_filter: customers_filter,
                                  };
                                });
                              }}
                            />
                          </div>
                          <div className="uu-w-max-content">
                            <FormFieldGenerator
                              fieldDefinition={{
                                "type": "select",
                                "params": {
                                  // "valuetype": "number",
                                  // "integer": true,
                                  "label": "Odgovori",
                                  "name": "customers_filter_2",
                                  "options": [
                                    { "title": "Prikaži sve", "value": "" },
                                    { "title": "Popunjene ankete", "value": "POPUNJENE" },
                                    { "title": "Ceka se odgovor", "value": "NA_CEKANJU" },
                                    { "title": "Istekle ankete", "value": "ISTEKLE" },
                                  ],
                                  // "outline": false,
                                  "withoutdefaultoption": true,
                                  "extraclass": "novo-radios-row",
                                }
                              }}
                              value={appState.customers_filter_2}
                              handleChange={(e) => {
                                const customers_filter_2 = e.target.value;
                                setAppState(state => {
                                  return {
                                    ...state,
                                    customers_filter_2: customers_filter_2,
                                  };
                                });
                              }}
                            />
                          </div>
                        </div>
                        <p>Legenda: crveni redovi znači da je dao loše ocene, žuto čeka se da odgovori, zeleno sve uredno.</p>
                        <ViewGeneratorSimple
                          viewDefinition={{
                            view_key: TABLE_CUSTOMERS,
                            table_additional_column_keys: [
                              "customer_id",
                              // "is_anonymous", // DM_: Sakriti ovo polje
                              "name",
                              // "surname",
                              "email",
                              //
                              "phone",
                              "location",
                              "cdp_sifra",
                              //
                              "is_low_ratings",
                              //
                              "last_sales_date",
                              "last_service_date",
                              "sales_count",
                              "service_count",
                              "pending_surveys_count",
                              "date_created",
                              "date_updated",
                            ],
                            table_additional_row_blueprint: {
                              extraClass: (row) => {
                                const entity = row;
                                if (entity?.is_low_ratings === true) {
                                  return ' zzsurvey__bg-highlighted zzsurvey__bg-highlighted--low-rating';
                                } else if (entity?.pending_surveys_count > 0) {
                                  return ' zzsurvey__bg-highlighted zzsurvey__bg-highlighted--pending';
                                } else if (entity?.filled_surveys_count > 0) {
                                  if (entity?.expired_surveys_count > 0) {
                                  } else {
                                    return ' zzsurvey__bg-highlighted zzsurvey__bg-highlighted--filled';
                                  }
                                }
                                //
                                return ' zzsurvey__bg-highlighted-NOT';
                              },
                            },
                            cbEntityKeyExtractor: (entity, index) => {
                              return entity.customer_id;
                            },
                            cbEntityColumnValExtractor: (entity, column_key) => {
                              const k = column_key;
                              const val = entity?.[k];
                              return val;
                            },
                            options: {
                              entity_col_disabled: true,
                              showSelectable: true,
                            },
                            cbRefresh: () => { fetchListUniversal(TABLE_CUSTOMERS); },
                            cbEntityActionsJsx: (entity, payload) => {
                              // return JSX action buttons
                              return (
                                <>
                                  <div className="">
                                    <Btn
                                      disabled={false}
                                      title={'Schedule a survey'}
                                      btnColor={'btn--color-mui-indigo'}
                                      btnSmallWithTitle
                                      inline
                                      i='fa fa-calendar-check-o'
                                      tooltip='Add survey'
                                      handleClick={() => {
                                        setModalPortableContent({
                                          options: {},
                                          jsx: (<ZZTempDialogUniversal
                                            mode={'ADD'}
                                            jsxHeader={<h2 className="heading-on-top">Add instance</h2>}
                                            initialState={{
                                              customer_id: entity.customer_id,
                                              service_date: new Date().toISOString().substring(0, 10),
                                              date_to_send_first_email: _zzsurvey_utils_make_date_now_plus_days(6),
                                              date_to_send_second_email: _zzsurvey_utils_make_date_now_plus_days(11),
                                              date_due: _zzsurvey_utils_make_date_now_plus_days(20),
                                            }}
                                            formDefinition={() => {
                                              return _zzsurvey_formDefiinitionInstance(_cb_survey_customer_arr, _cb_survey_template_arr);
                                            }}
                                            _cb_survey_template_arr={_cb_survey_template_arr}
                                            fetchingSubmit={appState.fetchingSubmit}
                                            cbSubmit={(entbox) => {
                                              const _entbox = { ...entbox };
                                              if (typeof entbox.email === 'string') {
                                                _entbox.email = entbox.email.trim().toLowerCase();
                                              }
                                              _entbox.customer_ids = [entbox.customer_id];
                                              _entbox.customer_id = null;
                                              fetchCreateUniversal(TABLE_INSTANCES, _entbox);
                                            }}
                                            cbCancel={() => { setModalPortableContent(false); }}
                                            componentDidMount={() => {
                                              fetchListUniversal(TABLE_CUSTOMERS);
                                              fetchListUniversal(TABLE_TEMPLATES);
                                            }}
                                          />),
                                        });
                                      }}
                                    />
                                    <Btn
                                      disabled={false}
                                      title={'Edit customer'}
                                      btnColor={'btn--color-mui-indigo'}
                                      btnSmall
                                      inline
                                      i='fa fa-pencil'
                                      tooltip='Edit customer'
                                      handleClick={() => {
                                        setModalPortableContent({
                                          options: {},
                                          jsx: (<ZZTempDialogUniversal
                                            mode={'EDIT'}
                                            jsxHeader={<h2 className="heading-on-top">Edit customer</h2>}
                                            initialState={{ ...entity }}
                                            formDefinition={() => {
                                              return _zzsurvey_formDefiinitionCustomer_v2(clients_of_seller);
                                            }}
                                            fetchingSubmit={appState.fetchingSubmit}
                                            cbSubmit={(entbox) => {
                                              const _entbox = entbox;
                                              if (typeof entbox.email === 'string') {
                                                _entbox.email = entbox.email.trim().toLowerCase();
                                              }
                                              fetchUpdateUniversal(TABLE_CUSTOMERS, _entbox);
                                            }}
                                            cbCancel={() => { setModalPortableContent(false); }}
                                            componentDidMount={() => { /* fetchListUniversal(TABLE_TEMPLATES); */ }}
                                          />),
                                        });
                                      }}
                                    />
                                    <Btn
                                      disabled={entity.is_active === false}
                                      title={'Delete customer'}
                                      btnColor={'btn--red'}
                                      btnSmall
                                      inline
                                      i='fa fa-trash'
                                      tooltip='Delete customer'
                                      handleClick={() => {
                                        if (window.confirm("Are you sure you want to delete customer?")) {
                                          // TODO
                                          // crudDeleteUniversal();
                                          _zzsurvey_ajax.deleteCustomer(entity.customer_id)
                                            .then(response => {
                                              console.log('deleteCustomer response', response);
                                              fetchListUniversal(TABLE_CUSTOMERS);
                                            })
                                            .catch(err => {
                                              console.log('CATCH error after axios', err);
                                              error_msg_handle(err);
                                            })
                                        }
                                      }}
                                    />
                                    {/*
                          <Btn
                            disabled={true}
                            title={''}
                            btnColor={'btn--color-mui-indigo'}
                            btnSmall
                            inline
                            i='fa fa-pencil'
                            tooltip='Edit entity'
                            handleClick={() => {
                              // const survey_template_arr = _extract_single_table_state(appState, TABLE_CUSTOMERS).data;
                              console.log('contextValue', contextValue);
                              // const survey_template_arr = contextValue.survey_template_arr;
                              // console.log('survey_template_arr', survey_template_arr);
                              setModalPortableContent({
                                options: {},
                                jsx: (<ZZTempDialogUniversal
                                  mode={'EDIT'}
                                  jsxHeader={<h2 className="heading-on-top">Edit customer</h2>}
                                  initialState={entity}
                                  formDefinition={() => {
                                    return _zzsurvey_formDefiinitionCustomer_v2(_cb_survey_template_arr);
                                  }}
                                  fetchingSubmit={appState.fetchingSubmit}
                                  cbSubmit={(data) => { fetchUpdateUniversal(TABLE_CUSTOMERS, data) }}
                                  cbCancel={() => { setModalPortableContent(false); }}
                                />),
                              });
                            }}
                          />
                          */}
                                  </div>
                                </>
                              );
                            },

                          }}
                          viewArr_OLD={_extract_single_table_state(appState, TABLE_CUSTOMERS).data}
                          viewArr={customers_filtered_arr}
                          fetching={_extract_single_table_state(appState, TABLE_CUSTOMERS).fetching}
                          jsxSpinner={<SpinnerClassic />}
                          cbOnSelectionChange={_handleMultipleCustomersSelectionChange}
                        />
                        <div className="zzsurvey__view-footer">
                          <Btn
                            disabled={false}
                            title={'Add customer'}
                            btnColor={'btn--color-mui-indigo'}
                            btnSmallWithTitle
                            inline
                            i='fa fa-plus'
                            tooltip='Add customer'
                            handleClick={() => {
                              setModalPortableContent({
                                options: {},
                                jsx: (<ZZTempDialogUniversal
                                  mode={'ADD'}
                                  jsxHeader={<h2 className="heading-on-top">Add customer</h2>}
                                  initialState={{}}
                                  formDefinition={() => {
                                    return _zzsurvey_formDefiinitionCustomer_v2(clients_of_seller);
                                  }}
                                  fetchingSubmit={appState.fetchingSubmit}
                                  cbSubmit={(entbox) => {
                                    const _entbox = entbox;
                                    if (typeof entbox.email === 'string') {
                                      _entbox.email = entbox.email.trim().toLowerCase();
                                    }
                                    fetchCreateUniversal(TABLE_CUSTOMERS, _entbox);
                                  }}
                                  cbCancel={() => { setModalPortableContent(false); }}
                                  componentDidMount={() => { /* fetchListUniversal(TABLE_TEMPLATES); */ }}
                                />),
                              });
                            }}
                          />
                          <Btn
                            disabled={!(appState.seller_selected_multiple_ccustomer_ids?.length > 0)}
                            title={'Schedule multiple surveys'}
                            btnColor={'btn--color-mui-indigo'}
                            btnSmallWithTitle
                            inline
                            i='fa fa-calendar-check-o'
                            tooltip='Add survey'
                            handleClick={() => {
                              setModalPortableContent({
                                options: {},
                                jsx: (<ZZTempDialogUniversal
                                  mode={'ADD'}
                                  jsxHeader={<h2 className="heading-on-top">Add multiple ({appState.seller_selected_multiple_ccustomer_ids.length}) instances</h2>}
                                  initialState={{
                                    customer_id: null,
                                    service_date: new Date().toISOString().substring(0, 10),
                                    date_to_send_first_email: _zzsurvey_utils_make_date_now_plus_days(6),
                                    date_to_send_second_email: _zzsurvey_utils_make_date_now_plus_days(11),
                                    date_due: _zzsurvey_utils_make_date_now_plus_days(20),
                                  }}
                                  formDefinition={() => {
                                    return _zzsurvey_formDefiinitionInstance(_cb_survey_customer_arr, _cb_survey_template_arr, true, appState.seller_selected_multiple_ccustomer_ids);
                                  }}
                                  fetchingSubmit={appState.fetchingSubmit}
                                  cbSubmit={(entbox) => {
                                    const _entbox = { ...entbox };
                                    if (typeof entbox.email === 'string') {
                                      _entbox.email = entbox.email.trim().toLowerCase();
                                    }
                                    _entbox.customer_ids = [...appState.seller_selected_multiple_ccustomer_ids];
                                    _entbox.customer_id = null;
                                    console.log('clck submit multiple instances', _entbox);
                                    fetchCreateUniversal(TABLE_INSTANCES, _entbox);
                                  }}
                                  cbCancel={() => { setModalPortableContent(false); }}
                                  componentDidMount={() => {
                                    // fetchListUniversal(TABLE_CUSTOMERS);
                                    fetchListUniversal(TABLE_TEMPLATES);
                                  }}
                                />),
                              });
                            }}
                          />
                          <Btn
                            disabled={false}
                            title={'Refresh'}
                            btnSmallWithTitle
                            inline
                            i='fa fa-refresh'
                            tooltip='Refresh'
                            handleClick={() => { fetchListUniversal(TABLE_CUSTOMERS); }}
                          />
                        </div>
                        <div className="uu-gap-standalone-32px"></div>
                        <section className="zzsurvey__import-customers-section">
                          <CardCollapsible small title="Import customers by CSV (or TSV)">
                            <div className="" style={{ width: '480px' }}>
                              <p>U prvom redu CSV-a, moraju biti nazivi kolona. Obavezna kolona je email a opcione kolone su name, phone, location, cdp_sifra. Pomenute kolone će biti importovane a sve ostale kolone će biti ignorisane.</p>
                              <p>Formu možete da popunite sa Copy/Paste iz Excel-a (u tom slučaju izaberite TSV).</p>
                            </div>
                            <FormCsvEditorWidget csvEditorWidgetPack={csvEditorWidgetPack} />
                            <br />
                            <Btn
                              inline
                              outline
                              circle
                              i='fa fa-magic'
                              title="Import"
                              handleClick={_popuniPutemCsv}
                            />
                          </CardCollapsible>
                        </section>
                      </SellerCardPage>

                      <SellerCardPage pageRouteActive={seller_route === 'TEMPLATES'} jsxHeader={<h1>Quiz templates</h1>} >
                        <ViewGeneratorSimple
                          viewDefinition={{
                            view_key: TABLE_TEMPLATES,
                            table_additional_column_keys: [
                              "survey_template_id",
                              "internal_name",
                              "title",
                              "text",
                              "img_url",
                              "service_type",
                              /*, "client_id"*/
                              "first_email_title",
                              // "first_email_content",
                              "second_email_title",
                              // "second_email_content",
                              "date_created_template",
                              //
                              "is_review",
                              "review_text",
                              "review_link",
                            ],
                            cbEntityKeyExtractor: (entity, index) => {
                              // console.log('cbEntityKeyExtractor', entity);
                              return entity.survey_template_id;
                            },
                            cbEntityColumnValExtractor: (entity, column_key) => {
                              const k = column_key;
                              const val = entity?.[k];
                              return val;
                            },
                            options: {
                              entity_col_disabled: true,
                            },
                            cbRefresh: () => { fetchListUniversal(TABLE_TEMPLATES); },
                            cbEntityActionsJsx: (entity, payload) => {
                              // return JSX action buttons
                              return (
                                <>
                                  <Btn
                                    disabled={false}
                                    title={''}
                                    btnColor={'btn--color-mui-green-darken-3'}
                                    btnSmall
                                    inline
                                    i='fa fa-eye'
                                    tooltip='Preview quiz'
                                    handleClick={() => {
                                      setModalPortableContent({
                                        options: { large: true },
                                        jsx: (
                                          <>
                                            <h3>Display quiz preview - template_id: {entity.survey_template_id}</h3>
                                            <ZZTempSurveyQuizFill
                                              mode={'LIVE_PREVIEW'}
                                              quiz_key={null}
                                              quizBlueprint={_zzsurvey_utils_backendQuizBlueprint_to_quizBlueprint(entity)}
                                              cbSubmit={(quiz_key, entbox) => { window.alert('This is just a display :)'); }}
                                            />
                                          </>
                                        ),
                                      });
                                    }}
                                  />
                                  <Btn
                                    disabled={false}
                                    title={'Add'}
                                    btnColor={'btn--color-mui-indigo'}
                                    btnSmall
                                    inline
                                    i='fa fa-clone'
                                    tooltip='Add quiz template based on existing'
                                    handleClick={() => {
                                      setModalPortableContent({
                                        options: { large: true },
                                        jsx: (
                                          <ZZTempSurveyQuizEditorContainer
                                            mode={'CLONE'}
                                            templateEntityToClone={entity}
                                            cbSubmit={(data) => { fetchCreateUniversal(TABLE_TEMPLATES, data) }}
                                            cbCancel={() => { setModalPortableContent(false) }}
                                          />
                                        ),
                                      });
                                    }}
                                  />
                                  {/*
                          <Btn
                            disabled={true}
                            title={''}
                            btnColor={'btn--color-mui-indigo'}
                            btnSmall
                            inline
                            i='fa fa-pencil'
                            tooltip='Edit entity'
                            handleClick={() => {
                              setModalPortableContent({
                                options: {},
                                jsx: (<ZZTempDialogUniversal
                                  disabled={true}
                                  mode={'EDIT'}
                                  jsxHeader={<h2 className="heading-on-top">Edit quiz</h2>}
                                  initialState={{...entity}}
                                  formDefinition={_zzsurvey_formDefiinitionCustomer_v2}
                                  fetchingSubmit={appState.fetchingSubmit}
                                  cbSubmit={(data) => { fetchUpdateUniversal(TABLE_TEMPLATES, data) }}
                                  cbCancel={() => { setModalPortableContent(false); }}
                                />),
                              });
                            }}
                          />
                          */}
                                  {/*
                          <Btn
                            disabled={true}
                            title={''}
                            btnColor={'btn--red'}
                            btnSmall
                            inline
                            i='fa fa-trash'
                            tooltip='Delete entity'
                            handleClick={() => {
                              if (window.confirm("Da li ste sigurni da želite da obrišete entitet?")) {
                                // TODO
                                crudDeleteUniversal();
                              }
                            }}
                          />
                          */}
                                </>
                              );
                            },

                          }}
                          viewArr={_extract_single_table_state(appState, TABLE_TEMPLATES).data}
                          fetching={_extract_single_table_state(appState, TABLE_TEMPLATES).fetching}
                          jsxSpinner={<SpinnerClassic />}
                        />
                        <div className="zzsurvey__view-footer">
                          <Btn
                            disabled={false}
                            title={'Add'}
                            btnColor={'btn--color-mui-indigo'}
                            btnSmallWithTitle
                            inline
                            i='fa fa-plus'
                            tooltip='Add quiz tebplate'
                            handleClick={() => {
                              setModalPortableContent({
                                options: { large: true },
                                jsx: (
                                  <ZZTempSurveyQuizEditorContainer
                                    mode={'REAL'}
                                    cbSubmit={(data) => { fetchCreateUniversal(TABLE_TEMPLATES, data) }}
                                    cbCancel={() => { setModalPortableContent(false) }}
                                  />
                                ),
                              });
                            }}
                          />
                          <Btn
                            disabled={false}
                            title={'Refresh'}
                            btnSmallWithTitle
                            inline
                            i='fa fa-refresh'
                            tooltip='Refresh'
                            handleClick={() => { fetchListUniversal(TABLE_TEMPLATES); }}
                          />
                        </div>
                      </SellerCardPage>

                      <SellerCardPage pageRouteActive={seller_route === 'INSTANCES'} jsxHeader={<h1>Answers / Survey instances FILLED</h1>} >
                        <ViewGeneratorSimple
                          viewDefinition={{
                            view_key: TABLE_INSTANCES,
                            table_additional_column_keys: [
                              "survey_instance_id", // ins
                              "status", // ins

                              "survey_template_id", // template
                              "service_type", // template
                              "internal_name", // template
                              "title", // template
                              "text", // template
                              "date_created_template", // template
                              // "first_email_title", // template
                              // "first_email_content", // template
                              // "second_email_title", // template
                              // "second_email_content", // template
                              "is_review",
                              // "review_text",
                              // "review_link",

                              "is_anonymous", // cus
                              "customer_id", // cus
                              "name", // cus
                              // "surname", // cus
                              "email", // cus

                              "date_filled", // ins
                              "service_date", // ins
                              "date_due", // ins
                              "is_first_email_sent", // ins
                              "is_second_email_sent", // ins
                              "date_to_send_first_email", // ins
                              "date_to_send_second_email", // ins
                            ],

                            cbEntityKeyExtractor: (entity, index) => {
                              return entity.survey_instance_id;
                            },
                            cbEntityColumnValExtractor: (entity, column_key) => {
                              // console.log('+++ cbEntityColumnValExtractor');
                              const k = column_key;
                              if (false) {
                                /*
                              } else if (k === "is_anonymous") {
                                // return entity?.[k];
                                return entity.is_anonymous;
                                // return entity?.customer?.[k];
                                */
                                /*
                               } else if (k === "customer_id") {
                                 return entity?.customer?.[k];
                                 */
                              } else if (k === "customer_id" || k === "name" || k === "email" || k === "phone" || k === "location" || k === "cdp_sifra") {
                                let is_anon = false;
                                // if (entity?.customer?.is_anonymous === true) {
                                // if (entity?.is_anonymous === true) {
                                if (entity.is_anonymous === true) {
                                  is_anon = true;
                                }
                                console.log('cbEntityColumnValExtractor is_anon', is_anon);
                                if (is_anon === true) { // hide values
                                  return null;
                                } else {
                                  return entity?.customer?.[k];
                                }
                                /*
                                "customer": {
                          "customer_id": 1,
                        "is_anonymous": false,
                        "name": "ispitanik",
                        "surname": "ispitanikovic",
                        "email": "ispitanik@ispitanik.com",
                        "date_created": "2025-03-04T09:43:29.000Z"
                                },
                        */
                              }
                              const val = entity?.[k];
                              return val;
                            },
                            options: {
                              entity_col_disabled: true,
                            },
                            cbRefresh: () => { fetchListUniversal(TABLE_INSTANCES); },
                            cbEntityActionsJsx: (entity, payload) => {
                              // return JSX action buttons
                              return (
                                <>
                                  <Btn
                                    disabled={false}
                                    title={'Answers'}
                                    btnColor={'btn--color-mui-green-darken-3'}
                                    btnSmallWithTitle
                                    inline
                                    i='fa fa-eye'
                                    tooltip='Display answers'
                                    handleClick={() => {
                                      setModalPortableContent({
                                        options: { large: true },
                                        jsx: (
                                          <>
                                            <h3>Display answers - instance_id: {entity.survey_instance_id}</h3>
                                            <ZZTempSurveyQuizFill
                                              mode={'LIVE_PREVIEW'}
                                              previewIsAnon={entity.is_anonymous}
                                              quiz_key={null}
                                              quizBlueprint={_zzsurvey_utils_backendQuizBlueprint_to_quizBlueprint(entity)}
                                              cbSubmit={(quiz_key, entbox) => { window.alert('This is just a display :)'); }}
                                            />
                                          </>
                                        ),
                                      });
                                    }}
                                  />
                                  {/*
                          <Btn
                            disabled={false}
                            title={''}
                            btnColor={'btn--color-mui-indigo'}
                            btnSmall
                            inline
                            i='fa fa-pencil'
                            tooltip='Edit entity'
                            handleClick={() => {
                              // setModalPortableContent();
                            }}
                          />
                          */}
                                  {/*
                          <Btn
                            disabled={true}
                            title={''}
                            btnColor={'btn--red'}
                            btnSmall
                            inline
                            i='fa fa-trash'
                            tooltip='Delete entity'
                            handleClick={() => {
                              if (window.confirm("Da li ste sigurni da želite da obrišete entitet?")) {
                                // TODO
                                crudDeleteUniversal();
                              }
                            }}
                          />
                        */}
                                </>
                              );
                            },

                          }}
                          viewArr={_extract_single_table_state(appState, TABLE_INSTANCES_FILLED).data}
                          fetching={_extract_single_table_state(appState, TABLE_INSTANCES_FILLED).fetching}
                          jsxSpinner={<SpinnerClassic />}
                        />
                        <div className="zzsurvey__view-footer">
                          <Btn
                            disabled={false}
                            title={'Schedule a survey'}
                            btnColor={'btn--color-mui-indigo'}
                            btnSmallWithTitle
                            inline
                            i='fa fa-calendar-check-o'
                            tooltip='Add survey'
                            handleClick={() => {
                              setModalPortableContent({
                                options: {},
                                jsx: (<ZZTempDialogUniversal
                                  mode={'ADD'}
                                  jsxHeader={<h2 className="heading-on-top">Add instance</h2>}
                                  initialState={{
                                    service_date: new Date().toISOString().substring(0, 10),
                                    date_to_send_first_email: _zzsurvey_utils_make_date_now_plus_days(6),
                                    date_to_send_second_email: _zzsurvey_utils_make_date_now_plus_days(11),
                                    date_due: _zzsurvey_utils_make_date_now_plus_days(20),
                                  }}
                                  formDefinition={() => {
                                    return _zzsurvey_formDefiinitionInstance(_cb_survey_customer_arr, _cb_survey_template_arr);
                                  }}
                                  fetchingSubmit={appState.fetchingSubmit}
                                  cbSubmit={(entbox) => {
                                    const _entbox = { ...entbox };
                                    if (typeof entbox.email === 'string') {
                                      _entbox.email = entbox.email.trim().toLowerCase();
                                    }
                                    _entbox.customer_ids = [entbox.customer_id];
                                    _entbox.customer_id = null;
                                    fetchCreateUniversal(TABLE_INSTANCES, _entbox);
                                  }}
                                  cbCancel={() => { setModalPortableContent(false); }}
                                  componentDidMount={() => {
                                    fetchListUniversal(TABLE_CUSTOMERS);
                                    fetchListUniversal(TABLE_TEMPLATES);
                                  }}
                                />),
                              });
                            }}
                          />
                          <Btn
                            disabled={_extract_single_table_state(appState, TABLE_INSTANCES_FILLED).fetching === true}
                            title={'Excel export'}
                            btnColor={'btn--color-mui-green-darken-3'}
                            btnSmallWithTitle
                            inline
                            i='fa fa-file-excel-o'
                            tooltip='Export to excel'
                            handleClick={() => { _zzsurvey_utils_export_excel_table_v0_1(_extract_single_table_state(appState, TABLE_INSTANCES_FILLED).data); }}
                          />
                          <Btn
                            disabled={false}
                            title={'Excel export SVE *'}
                            btnColor={'btn--color-mui-green-darken-3'}
                            btnSmallWithTitle
                            inline
                            i='fa fa-file-excel-o'
                            tooltip='Export to excel'
                            handleClick={() => { _zzsurvey_utils_export_excel_table_v0_1(_extract_single_table_state(appState, TABLE_INSTANCES_FILLED).data, true); }}
                          />
                          <Btn
                            disabled={false}
                            title={'Refresh'}
                            btnSmallWithTitle
                            inline
                            i='fa fa-refresh'
                            tooltip='Refresh'
                            handleClick={() => { fetchListUniversal(TABLE_INSTANCES); }}
                          />
                          {/*
                  <Btn
                    disabled={false}
                    title={''}
                    btnSmall
                    inline
                    i='fa fa-refresh'
                    tooltip='Refresh'
                    handleClick={() => { fetchListUniversal(TABLE_INSTANCES); }}
                  />
                  */}
                        </div>
                      </SellerCardPage>

                      <SellerCardPage pageRouteActive={seller_route === 'GOOGLE_REVIEWS'} jsxHeader={<h1>Google reviews</h1>} >
                        <FrfrUtilsCbWhenMounted componentDidMount={() => { fetchListUniversal(TABLE_GOOGLE_REVIEWS, { api_key: '', place_id: '' }); }} />
                        {/*
                          useEffect(() => {
                            if (appState.ulogovan === true && appState.google_reviews_api_key && appState.google_reviews_place_id) {
                              fetchListUniversal(TABLE_GOOGLE_REVIEWS, {
                                api_key: appState.google_reviews_api_key,
                                place_id: appState.google_reviews_place_id,
                              });
                            }
                          }}, [appState.google_reviews_api_key, appState.google_reviews_place_id, appState.ulogovan]);
                        */}
                        <FrfrUtilsCbUseEffect
                          cb={() => {
                            if (appState.ulogovan === true && appState.google_reviews_api_key && appState.google_reviews_place_id) {
                              fetchListUniversal(TABLE_GOOGLE_REVIEWS, {
                                api_key: appState.google_reviews_api_key,
                                place_id: appState.google_reviews_place_id,
                              });
                            }
                          }}
                          dependencies={[appState.google_reviews_api_key, appState.google_reviews_place_id, appState.ulogovan]}
                        />
                        <div>
                          <div className="zzsurvey__card">
                            <div><b>Unesite google reviews API podatke</b></div>
                            <div className="zz-novo-form-simple">
                              <FormGenerator
                                formDefinition={_zzsurvey_formDefinitionGoogleReviewsApi()}
                                formState={appState}
                                formErrors={{}}
                                handleChange={(e) => {
                                  setAppState(state => {
                                    const name = e.target.name;
                                    const value = e.target.value;
                                    return {
                                      ...state,
                                      [name]: value,
                                    };
                                  })
                                }}
                              />
                              <div>
                                <div className="uu-gap-standalone-12px"></div>
                                <Btn
                                  inline
                                  circle
                                  outline
                                  title="Save google parameters"
                                  i={'fa fa-floppy-o'}
                                  handleClick={() => {
                                    const api_key = appState.google_reviews_api_key;
                                    const place_id = appState.google_reviews_place_id;
                                    _zzsurvey_ajax.updateClientParams({
                                      api_key,
                                      place_id,
                                      client_id: appState.seller_selected_client_id,
                                    })
                                      .then(response => {
                                        console.log('updateClientParams response', response);
                                        if (typeof response?.data?.message === 'string') {
                                          dispatchShowToast(response.data.message, 'BLUE');
                                        }
                                      })
                                      .catch(err => {
                                        console.log('CATCH error after axios', err);
                                        error_msg_handle(err);
                                      })
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="uu-gap-standalone-4px"></div>
                        <h2>Results</h2>
                        {
                          google_reviews_fetching === true && (
                            <>
                              <div className="uu-gap-standalone-8px"></div>
                              <SpinnerClassic />
                              <div className="uu-gap-standalone-8px"></div>
                            </>
                          )
                        }
                        <div>
                          <div><b>Google Reviews form link</b>: <a target="_blank" rel="noopener noreferrer" href={google_reviews_form_link}>{google_reviews_form_link}</a></div>
                        </div>
                        <div className="zzsurvey__google-review-vector">
                          {
                            Array.isArray(google_reviews_arr) && (
                              <>
                                {
                                  google_reviews_arr.map((item, index) => {
                                    return (
                                      <div key={index} className="xi">
                                        <div key={index} className="zzsurvey__card zzsurvey__card--google-review">
                                          <div className="uu-gap-standalone-12px"></div>
                                          <div className="zzsurvey__google-review-author-columns">
                                            <div className="zzsurvey__google-review-author-columns__avatar">
                                              <a target="_blank" rel="noopener noreferrer" href={item.profile_photo_url}><img src={item.profile_photo_url} alt="Google review author avatar" /></a>
                                            </div>
                                            <div className="uu-flex-1">
                                              <div><b><a target="_blank" rel="noopener noreferrer" href={item.author_url}>{item.author_name}</a></b></div>
                                              {/*<div><a target="_blank" rel="noopener noreferrer" href={item.profile_photo_url}>Profile photo URL</a></div>*/}
                                              <div className="zzsurvey__google-review-author-columns__small zzsurvey__google-review-author-columns__timing zzsurvey__google-review-author-columns__gray">
                                                <span className="zzsurvey__google-review-author-columns__gray">{item.relative_time_description}</span>
                                                <span>(<span className="zzsurvey__google-review-author-columns__gray">Language: {item.language}</span><span className="zzsurvey__google-review-author-columns__gray">Original language: {item.original_language}</span>)                                            </span>
                                              </div>
                                            </div>
                                          </div>
                                          <div><b>Rating</b>: <b>{item.rating}</b></div>
                                          <div>{item.text}</div>
                                        </div>
                                      </div>
                                    );
                                  })
                                }
                              </>
                            )
                          }
                        </div>
                      </SellerCardPage>

                      <SellerCardPage pageRouteActive={seller_route === 'ALERTS'} jsxHeader={<h1>Alerts</h1>} >
                        {/*<p>Answers with low ratings...</p>*/}
                        <p>Ovde su prikazane popunjene ankete u kojima je u nekom od odgovara data ocena 3 ili manje.</p>
                        <ViewGeneratorSimple
                          viewDefinition={{
                            view_key: TABLE_INSTANCES,
                            table_additional_column_keys: [
                              "survey_instance_id", // ins
                              "status", // ins

                              "survey_template_id", // template
                              "service_type", // template
                              "internal_name", // template
                              "title", // template
                              "text", // template
                              "date_created_template", // template
                              // "first_email_title", // template
                              // "first_email_content", // template
                              // "second_email_title", // template
                              // "second_email_content", // template
                              "is_review",
                              // "review_text",
                              // "review_link",

                              "is_anonymous", // cus
                              "customer_id", // cus
                              "name", // cus
                              // "surname", // cus
                              "email", // cus

                              "date_filled", // ins
                              "service_date", // ins
                              "date_due", // ins
                              "is_first_email_sent", // ins
                              "is_second_email_sent", // ins
                              "date_to_send_first_email", // ins
                              "date_to_send_second_email", // ins
                            ],

                            cbEntityKeyExtractor: (entity, index) => {
                              return entity.survey_instance_id;
                            },
                            cbEntityColumnValExtractor: (entity, column_key) => {
                              // console.log('+++ cbEntityColumnValExtractor');
                              const k = column_key;
                              if (false) {
                                /*
                              } else if (k === "is_anonymous") {
                                // return entity?.[k];
                                return entity.is_anonymous;
                                // return entity?.customer?.[k];
                                */
                                /*
                               } else if (k === "customer_id") {
                                 return entity?.customer?.[k];
                                 */
                              } else if (k === "customer_id" || k === "name" || k === "email" || k === "phone" || k === "location" || k === "cdp_sifra") {
                                let is_anon = false;
                                // if (entity?.customer?.is_anonymous === true) {
                                // if (entity?.is_anonymous === true) {
                                if (entity.is_anonymous === true) {
                                  is_anon = true;
                                }
                                console.log('cbEntityColumnValExtractor is_anon', is_anon);
                                if (is_anon === true) { // hide values
                                  return null;
                                } else {
                                  return entity?.customer?.[k];
                                }
                                /*
                                "customer": {
                          "customer_id": 1,
                        "is_anonymous": false,
                        "name": "ispitanik",
                        "surname": "ispitanikovic",
                        "email": "ispitanik@ispitanik.com",
                        "date_created": "2025-03-04T09:43:29.000Z"
                                },
                        */
                              }
                              const val = entity?.[k];
                              return val;
                            },
                            options: {
                              entity_col_disabled: true,
                            },
                            cbRefresh: () => {
                              fetchListUniversal(TABLE_CUSTOMERS);
                              fetchListUniversal(TABLE_INSTANCES);
                            },
                            cbEntityActionsJsx: (entity, payload) => {
                              // return JSX action buttons
                              return (
                                <>
                                  <Btn
                                    disabled={false}
                                    title={'Answers'}
                                    btnColor={'btn--color-mui-green-darken-3'}
                                    btnSmallWithTitle
                                    inline
                                    i='fa fa-eye'
                                    tooltip='Display answers'
                                    handleClick={() => {
                                      setModalPortableContent({
                                        options: { large: true },
                                        jsx: (
                                          <>
                                            <h3>Display answers - instance_id: {entity.survey_instance_id}</h3>
                                            <ZZTempSurveyQuizFill
                                              mode={'LIVE_PREVIEW'}
                                              previewIsAnon={entity.is_anonymous}
                                              quiz_key={null}
                                              quizBlueprint={_zzsurvey_utils_backendQuizBlueprint_to_quizBlueprint(entity)}
                                              cbSubmit={(quiz_key, entbox) => { window.alert('This is just a display :)'); }}
                                            />
                                          </>
                                        ),
                                      });
                                    }}
                                  />
                                </>
                              );
                            },

                          }}
                          viewArr={alerts_survey_instance_arr}
                          fetching={instances_for_alerts_fetching}
                          jsxSpinner={<SpinnerClassic />}
                        />
                      </SellerCardPage>

                      <SellerCardPage pageRouteActive={seller_route === 'CDP_CUSTOMERS'} jsxHeader={<h1>CDP Customers</h1>} >
                        {/*<div>UNDER CONSTRUCTION...</div>*/}
                        <ViewGeneratorSimple
                          viewDefinition={{
                            view_key: TABLE_CDP_CUSTOMERS,
                            table_additional_column_keys: [
                              "cdp_sifra",
                              "cdp_customer_id",
                              // "is_anonymous", // DM_: Sakriti ovo polje
                              "name",
                              // "surname",
                              "email",
                              //
                              "phone",
                              "location",
                              // "cdp_sifra",
                              //
                              //
                            ],
                            cbEntityKeyExtractor: (entity, index) => {
                              return entity.cdp_customer_id;
                            },
                            cbEntityColumnValExtractor: (entity, column_key) => {
                              const k = column_key;
                              const val = entity?.[k];
                              return val;
                            },
                            options: {
                              entity_col_disabled: true,
                              showSelectable: false,
                            },
                            cbRefresh: () => { fetchListUniversal(TABLE_CDP_CUSTOMERS); },
                            cbEntityActionsJsx: (entity, payload) => {
                              // return JSX action buttons
                              return (
                                <>
                                  <div className="">
                                    <Btn
                                      disabled={false}
                                      title={'Sign consent'}
                                      btnColor={'btn--color-mui-indigo'}
                                      btnSmallWithTitle
                                      inline
                                      i='fa fa-certificate'
                                      tooltip='Sign consent'
                                      handleClick={() => {
                                        setModalPortableContent({
                                          options: {},
                                          jsx: (
                                            <>
                                              <ZZTempDialogSignConsent
                                                jsxHeader={<h2 className="heading-on-top">Sign consent with QR code</h2>}
                                                mode={'EDIT'}
                                                initialState={{
                                                  cdp_customer_id: entity.cdp_customer_id,
                                                  cdp_sifra: entity.cdp_sifra,
                                                  // consent_id: 1, // TODO
                                                  consent_id: '', // TODO
                                                }}
                                                appState={appState}
                                                cbRefresh={() => { fetchListUniversal(TABLE_CONSENTS); }}
                                                formDefinition={() => {
                                                  return _zzsurvey_formDefiinitionSignConsent(_cb_consents_arr);
                                                }}
                                                _zzsurvey_formDefiinitionSignConsent={_zzsurvey_formDefiinitionSignConsent}
                                                consents_arr={_extract_single_table_state(appState, TABLE_CONSENTS).data}
                                                _extract_single_table_state={_extract_single_table_state}
                                                cbFormState={(formState) => {
                                                  return (
                                                    <>
                                                      <ZZTempQRCodeForSignConsent formState={formState} />
                                                    </>
                                                  );
                                                }}
                                              />
                                              {/*
                                              <ZZTempDialogUniversal
                                                mode={'ADD'}
                                                jsxHeader={<h2 className="heading-on-top">Sign consent QR code</h2>}
                                                initialState={{
                                                  cdp_customer_id: entity.cdp_customer_id,
                                                  cdp_sifra: entity.cdp_sifra,
                                                  // consent_id: 1, // TODO
                                                  consent_id: '', // TODO
                                                }}
                                                formDefinition={() => {
                                                  return _zzsurvey_formDefiinitionSignConsent(_cb_consents_arr);
                                                }}
                                                _cb_survey_template_arr={_cb_survey_template_arr}
                                                fetchingSubmit={appState.fetchingSubmit}
                                                cbSubmit={(entbox) => {
                                                  // TODO
                                                }}
                                                cbCancel={() => { setModalPortableContent(false); }}
                                                componentDidMount={() => {
                                                  // TODO
                                                  fetchListUniversal(TABLE_CONSENTS);
                                                }}
                                                cbFormState={(formState) => {
                                                  return (
                                                    <>
                                                      <ZZTempQRCodeForSignConsent formState={formState} />
                                                    </>
                                                  );
                                                }}
                                              />
                                              */}
                                            </>
                                          ),
                                        });
                                      }}
                                    />
                                    <Btn
                                      disabled={false}
                                      title={'Edit CDP customer'}
                                      btnColor={'btn--color-mui-indigo'}
                                      btnSmall
                                      inline
                                      i='fa fa-pencil'
                                      tooltip='Edit CDP customer'
                                      handleClick={() => {
                                        setModalPortableContent({
                                          options: {},
                                          jsx: (<ZZTempDialogUniversal
                                            mode={'EDIT'}
                                            jsxHeader={<h2 className="heading-on-top">Edit CDP customer</h2>}
                                            initialState={{ ...entity }}
                                            formDefinition={() => {
                                              return _zzsurvey_formDefiinitionCustomer_v2(clients_of_seller);
                                            }}
                                            fetchingSubmit={appState.fetchingSubmit}
                                            cbSubmit={(entbox) => {
                                              const _entbox = entbox;
                                              if (typeof entbox.email === 'string') {
                                                _entbox.email = entbox.email.trim().toLowerCase();
                                              }
                                              fetchUpdateUniversal(TABLE_CDP_CUSTOMERS, _entbox);
                                            }}
                                            cbCancel={() => { setModalPortableContent(false); }}
                                            componentDidMount={() => { fetchListUniversal(TABLE_CONSENTS); }}
                                          />),
                                        });
                                      }}
                                    />
                                    <Btn
                                      disabled={entity.is_active === false}
                                      title={'Delete CDP customer'}
                                      btnColor={'btn--red'}
                                      btnSmall
                                      inline
                                      i='fa fa-trash'
                                      tooltip='Delete CDP customer'
                                      handleClick={() => {
                                        if (window.confirm("Are you sure you want to delete customer?")) {
                                          // TODO
                                          // crudDeleteUniversal();
                                          _zzsurvey_ajax.deleteCdpCustomer(entity.customer_id)
                                            .then(response => {
                                              console.log('deleteCdpCustomer response', response);
                                              fetchListUniversal(TABLE_CDP_CUSTOMERS);
                                            })
                                            .catch(err => {
                                              console.log('CATCH error after axios', err);
                                              error_msg_handle(err);
                                            })
                                        }
                                      }}
                                    />
                                  </div>
                                </>
                              );
                            },

                          }}
                          viewArr={_extract_single_table_state(appState, TABLE_CDP_CUSTOMERS).data}
                          fetching={_extract_single_table_state(appState, TABLE_CDP_CUSTOMERS).fetching}
                          jsxSpinner={<SpinnerClassic />}
                          cbOnSelectionChange={_handleMultipleCustomersSelectionChange}
                        />
                        <div className="zzsurvey__view-footer">
                          <Btn
                            disabled={false}
                            title={'Add CDP customer'}
                            btnColor={'btn--color-mui-indigo'}
                            btnSmallWithTitle
                            inline
                            i='fa fa-plus'
                            tooltip='Add CDP customer'
                            handleClick={() => {
                              setModalPortableContent({
                                options: {},
                                jsx: (<ZZTempDialogUniversal
                                  mode={'ADD'}
                                  jsxHeader={<h2 className="heading-on-top">Add CDP customer</h2>}
                                  initialState={{}}
                                  formDefinition={() => {
                                    return _zzsurvey_formDefiinitionCdpCustomer(clients_of_seller);
                                  }}
                                  fetchingSubmit={appState.fetchingSubmit}
                                  cbSubmit={(entbox) => {
                                    const _entbox = entbox;
                                    if (typeof entbox.email === 'string') {
                                      _entbox.email = entbox.email.trim().toLowerCase();
                                    }
                                    fetchCreateUniversal(TABLE_CDP_CUSTOMERS, _entbox);
                                  }}
                                  cbCancel={() => { setModalPortableContent(false); }}
                                  componentDidMount={() => { /* fetchListUniversal(TABLE_TEMPLATES); */ }}
                                />),
                              });
                            }}
                          />
                          <Btn
                            disabled={false}
                            title={'Refresh'}
                            btnSmallWithTitle
                            inline
                            i='fa fa-refresh'
                            tooltip='Refresh'
                            handleClick={() => { fetchListUniversal(TABLE_CDP_CUSTOMERS); }}
                          />
                        </div>
                        <div className="uu-gap-standalone-32px"></div>
                        <section className="zzsurvey__import-customers-section">
                          <CardCollapsible small title="Import CDP customers by CSV (or TSV)">
                            <div className="" style={{ width: '480px' }}>
                              <p>U prvom redu CSV-a, moraju biti nazivi kolona. Obavezna kolona je cdp_sifra a opcione kolone su email, name, phone, location. Pomenute kolone će biti importovane a sve ostale kolone će biti ignorisane.</p>
                              <p>Formu možete da popunite sa Copy/Paste iz Excel-a (u tom slučaju izaberite TSV).</p>
                            </div>
                            <FormCsvEditorWidget csvEditorWidgetPack={csvEditorWidgetPack} />
                            <br />
                            <Btn
                              inline
                              outline
                              circle
                              i='fa fa-magic'
                              title="Import"
                              handleClick={_popuniPutemCsv_CdpCustomers}
                            />
                          </CardCollapsible>
                        </section>

                      </SellerCardPage>

                      <SellerCardPage pageRouteActive={seller_route === 'CONSENTS'} jsxHeader={<h1>Consents</h1>} >
                        {/*<div>UNDER CONSTRUCTION...</div>*/}
                        <FrfrUtilsCbWhenMounted componentDidMount={() => { fetchListUniversal(TABLE_CONSENTS); }} />
                        <ViewGeneratorSimple
                          viewDefinition={{
                            view_key: TABLE_CONSENTS,
                            table_additional_column_keys: [
                              "consent_id",
                              "internal_name",
                              //
                              "title",
                              //
                              "text",
                              "terms_text",
                              //
                              //
                            ],
                            cbEntityKeyExtractor: (entity, index) => {
                              return entity.consent_id;
                            },
                            cbEntityColumnValExtractor: (entity, column_key) => {
                              const k = column_key;
                              const val = entity?.[k];
                              return val;
                            },
                            options: {
                              entity_col_disabled: true,
                              showSelectable: false,
                            },
                            cbRefresh: () => { fetchListUniversal(TABLE_CONSENTS); },
                            cbEntityActionsJsx: (entity, payload) => {
                              // return JSX action buttons
                              return (
                                <>
                                  <div className="">
                                    {/*
                                    <Btn
                                      disabled={false}
                                      title={'Edit consent text'}
                                      btnColor={'btn--color-mui-indigo'}
                                      btnSmall
                                      inline
                                      i='fa fa-pencil'
                                      tooltip='Edit CDP customer'
                                      handleClick={() => {
                                      }}
                                    />
                                    <Btn
                                      disabled={entity.is_active === false}
                                      title={'Delete consent text'}
                                      btnColor={'btn--red'}
                                      btnSmall
                                      inline
                                      i='fa fa-trash'
                                      tooltip='Delete consent text'
                                      handleClick={() => {
                                      }}
                                    />
                                    */}
                                  </div>
                                </>
                              );
                            },

                          }}
                          viewArr={_extract_single_table_state(appState, TABLE_CONSENTS).data}
                          fetching={_extract_single_table_state(appState, TABLE_CONSENTS).fetching}
                          jsxSpinner={<SpinnerClassic />}
                          cbOnSelectionChange={_handleMultipleCustomersSelectionChange}
                        />
                        <div className="zzsurvey__view-footer">
                          <Btn
                            disabled={false}
                            title={'Add consent text'}
                            btnColor={'btn--color-mui-indigo'}
                            btnSmallWithTitle
                            inline
                            i='fa fa-plus'
                            tooltip='Add consent text'
                            handleClick={() => {
                              setModalPortableContent({
                                options: {},
                                jsx: (<ZZTempDialogUniversal
                                  mode={'ADD'}
                                  jsxHeader={<h2 className="heading-on-top">Add consent text</h2>}
                                  initialState={{}}
                                  formDefinition={() => {
                                    return _zzsurvey_formDefiinitionConsent();
                                  }}
                                  fetchingSubmit={appState.fetchingSubmit}
                                  cbSubmit={(entbox) => {
                                    const _entbox = entbox;
                                    if (typeof entbox.email === 'string') {
                                      _entbox.email = entbox.email.trim().toLowerCase();
                                    }
                                    fetchCreateUniversal(TABLE_CONSENTS, _entbox);
                                  }}
                                  cbCancel={() => { setModalPortableContent(false); }}
                                  componentDidMount={() => { /* fetchListUniversal(TABLE_TEMPLATES); */ }}
                                />),
                              });
                            }}
                          />
                          <Btn
                            disabled={false}
                            title={'Refresh'}
                            btnSmallWithTitle
                            inline
                            i='fa fa-refresh'
                            tooltip='Refresh'
                            handleClick={() => { fetchListUniversal(TABLE_CONSENTS); }}
                          />
                        </div>
                        <div className="uu-gap-standalone-32px"></div>
                        <section className="zzsurvey__import-customers-section">
                          <CardCollapsible small title="* example consent text">
                            <div className="" style={{ width: '480px' }}>
                              <textarea style={{
                                minWidth: '320px',
                                minHeight: '100px'
                              }}>{consent_1_text_20250506}</textarea>
                            </div>
                          </CardCollapsible>
                        </section>
                      </SellerCardPage>

                      <SellerCardPage pageRouteActive={seller_route === 'SIGNATURES'} jsxHeader={<h1>Signatures</h1>} >
                        {/*<div>UNDER CONSTRUCTION...</div>*/}
                        <p>Which cdp_customer signed which consent...</p>

                        <ViewGeneratorSimple
                          viewDefinition={{
                            view_key: TABLE_SIGNATURES,
                            table_additional_column_keys: [
                              //
                              "cdp_sifra",
                              "email",
                              "location",
                              //
                              //
                              "signature_id",
                              "accepts_terms",
                              "signature_url",
                              "date_created",
                              //
                              "consent_id",
                              "internal_name",
                              //
                              // "cdp_customer_id",
                              //
                              //
                            ],
                            cbEntityKeyExtractor: (entity, index) => {
                              return entity.signature_id;
                            },
                            cbEntityColumnValExtractor: (entity, column_key) => {
                              const k = column_key;
                              const val = entity?.[k];
                              return val;
                            },
                            cbEntityColumnValCustomDisplay: (column_key, val) => {
                              const k = column_key;
                              //
                              if (k === "signature_url") {
                                const _val_custome_display = (
                                  <div className="zzsurvey__signature-img-widget-in-cell" onClick={() => {
                                    setModalPortableContent({
                                      options: { large: true },
                                      jsx: (
                                        <div>
                                          <img src={val} alt="signature" />
                                          <div>
                                            <a target="_blank" rel="noopener noreferrer" href={val}>Open image</a>
                                          </div>
                                          <div>
                                            <a target="_blank" rel="noopener noreferrer" href={val} download>Download image</a>
                                          </div>
                                        </div>
                                      ),
                                    });
                                  }}>
                                    {/*<a target="_blank" rel="noopener noreferrer" href={val}><img src={val} alt="signature" /></a>*/}
                                    <img src={val} alt="signature" />
                                  </div>
                                );
                                return _val_custome_display;
                              }
                              // else
                              return false; // will be default val display
                            },
                            options: {
                              entity_col_disabled: true,
                              showSelectable: false,
                            },
                            cbRefresh: () => { fetchListUniversal(TABLE_SIGNATURES); },
                            cbEntityActionsJsx: (entity, payload) => {
                              // return JSX action buttons
                              return (
                                <>
                                  <div className="">
                                    {/*
                                    <Btn
                                      disabled={false}
                                      title={'Edit consent text'}
                                      btnColor={'btn--color-mui-indigo'}
                                      btnSmall
                                      inline
                                      i='fa fa-pencil'
                                      tooltip='Edit CDP customer'
                                      handleClick={() => {
                                      }}
                                    />
                                    <Btn
                                      disabled={entity.is_active === false}
                                      title={'Delete consent text'}
                                      btnColor={'btn--red'}
                                      btnSmall
                                      inline
                                      i='fa fa-trash'
                                      tooltip='Delete consent text'
                                      handleClick={() => {
                                      }}
                                    />
                                    */}
                                  </div>
                                </>
                              );
                            },

                          }}
                          viewArr={signatures_arr}
                          fetching={_extract_single_table_state(appState, TABLE_SIGNATURES).fetching}
                          jsxSpinner={<SpinnerClassic />}
                          cbOnSelectionChange={_handleMultipleCustomersSelectionChange}
                        />
                        <div className="zzsurvey__view-footer">
                          <Btn
                            disabled={false}
                            title={'Refresh'}
                            btnSmallWithTitle
                            inline
                            i='fa fa-refresh'
                            tooltip='Refresh'
                            handleClick={() => { fetchListUniversal(TABLE_SIGNATURES); }}
                          />
                        </div>
                      </SellerCardPage>
                    </SellerCardPage>
                  ) : (
                    <>
                      <div>
                        <h2>Seller Admin Panel</h2>
                        <span><i><b>You must sellect client first.</b></i></span>
                      </div>
                    </>
                  )
                }




                <ModalPortableContainer
                  opened={modalPortableContent !== false}
                  cbClose={() => { setModalPortableContent(false) }}
                  ComponentModal={ModalBottomSheetKoglovoPresentational}
                  options={modalPortableContent?.options}
                >
                  {
                    modalPortableContent && modalPortableContent.jsx && (modalPortableContent.jsx)
                  }
                </ModalPortableContainer>
              </div>
              <div className="zzsurvey__layout-page-footer">Copyright © 2025 Žarko Turićanin, Dušan Mitrović, Jovan Petrović</div>
            </div>
          </div>
        </div>
      </div>
    </ZZTempSurveyContext.Provider>
  );
};

export default ZZTempSurvey;